
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3093"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3093"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dB6Iv", function(module, exports) {

$parcel$export(module.exports, "getCssVariable", function () { return $9e63f0e06daa8ca3$export$246d3e180f7f2ea; });
$parcel$export(module.exports, "isLandscape", function () { return $9e63f0e06daa8ca3$export$5cd843239dff6e53; });
$parcel$export(module.exports, "prefersReducedMotion", function () { return $9e63f0e06daa8ca3$export$ff7706047246b98b; });
$parcel$export(module.exports, "debounce", function () { return $9e63f0e06daa8ca3$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "scrollToTop", function () { return $9e63f0e06daa8ca3$export$f5d3771428a1f489; });
$parcel$export(module.exports, "isIOS", function () { return $9e63f0e06daa8ca3$export$fedb369cb70207f1; });
$parcel$export(module.exports, "getMicrocopySlots", function () { return $9e63f0e06daa8ca3$export$daf0457f4d9a31bc; });
$parcel$export(module.exports, "localizeLegalLinks", function () { return $9e63f0e06daa8ca3$export$5d38e929a3a82f75; });
$parcel$export(module.exports, "onError", function () { return $9e63f0e06daa8ca3$export$2288787135a8f66e; });
$parcel$export(module.exports, "useDarkMode", function () { return $9e63f0e06daa8ca3$export$4673cbff94e146e2; });
$parcel$export(module.exports, "setDarkModeMessage", function () { return $9e63f0e06daa8ca3$export$1df5b7c8b7b79c6b; });

var $1n4Kt = parcelRequire("1n4Kt");

var $bNTxO = parcelRequire("bNTxO");

var $8ucNL = parcelRequire("8ucNL");
const $9e63f0e06daa8ca3$export$246d3e180f7f2ea = (key)=>{
    const computedStyle = getComputedStyle(document.documentElement);
    return computedStyle.getPropertyValue(key).trim();
};
const $9e63f0e06daa8ca3$export$5cd843239dff6e53 = ()=>window.innerWidth >= window.innerHeight;
const $9e63f0e06daa8ca3$export$ff7706047246b98b = ()=>!!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $9e63f0e06daa8ca3$export$61fc7d43ac8f84b0 = (fn, wait)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>fn(...args), wait);
    };
};
const $9e63f0e06daa8ca3$export$f5d3771428a1f489 = ()=>{
    if ($9e63f0e06daa8ca3$export$ff7706047246b98b()) {
        window.scrollTo(0, 0);
        return;
    }
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
        window.requestAnimationFrame($9e63f0e06daa8ca3$export$f5d3771428a1f489);
        window.scrollTo(0, c - c / 4);
    }
};
const $9e63f0e06daa8ca3$export$fedb369cb70207f1 = ()=>[
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || // iPad on iOS 13 detection
    navigator.userAgent.includes('Mac') && 'ontouchend' in document;
const $9e63f0e06daa8ca3$export$1bea650e3612c3b4 = (error)=>{
    document.documentElement.classList.add('no-js');
    document.querySelector('div.loading-screen').classList.add('hidden');
    const unwrap = (wrapper)=>{
        const docFrag = document.createDocumentFragment();
        while(wrapper.firstChild){
            const span = document.createElement('span');
            span.innerHTML = wrapper.removeChild(wrapper.firstChild).textContent;
            docFrag.appendChild(span);
        }
        wrapper.parentNode.replaceChild(docFrag, wrapper);
    };
    const noscript = document.querySelectorAll('noscript');
    for(let i = 0; i < noscript.length; i++)unwrap(noscript[i]);
    window.scrollTo(0, 0);
    if (error) {
        const warning = document.querySelector('code.warning');
        if (warning) warning.textContent = 'Something went wrong while loading the page. Please reload.';
    }
};
const $9e63f0e06daa8ca3$export$daf0457f4d9a31bc = ()=>Array.from(document.querySelectorAll('.microcopy'));
const $9e63f0e06daa8ca3$export$5d38e929a3a82f75 = (lang)=>{
    const language = (0, $8ucNL.LEGAL_PAGES).impressum.slug[lang] ? lang : 'en';
    document.querySelectorAll('.legal-links a').forEach((a)=>{
        const page = (0, $8ucNL.legalPageFromPath)(a.getAttribute('href') || '');
        if (page) a.setAttribute('href', (0, $8ucNL.LEGAL_PAGES)[page].slug[language]);
    });
    const cookieLink = document.querySelector('.legal-links .cookie-settings');
    if (cookieLink) cookieLink.textContent = (0, $8ucNL.COOKIE_SETTINGS_LABEL)[language];
};
const $9e63f0e06daa8ca3$export$2288787135a8f66e = (error)=>{
    console.error(error);
    $9e63f0e06daa8ca3$export$1bea650e3612c3b4(error);
};
const $9e63f0e06daa8ca3$export$4673cbff94e146e2 = ()=>{
    if (!window.matchMedia) return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    if (mq.matches) document.documentElement.classList.add('dark-mode');
    mq.addEventListener('change', (e)=>{
        document.documentElement.classList.toggle('dark-mode', e.matches);
        $9e63f0e06daa8ca3$export$1df5b7c8b7b79c6b();
    });
};
const $9e63f0e06daa8ca3$export$1df5b7c8b7b79c6b = ()=>{
    const isDarkMode = document.documentElement.classList.contains('dark-mode');
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.setAttribute('content', isDarkMode ? '#1d1d1d' : '#fdfdfd');
    // The legal pages have no toolbar.
    const inverterButton = document.querySelector('button.inverter');
    if (!inverterButton) return;
    const lang = document.documentElement.lang;
    const message = lang === 'de' ? `Zu ${isDarkMode ? 'hellem' : 'dunklem'} Modus wechseln` : `Switch to ${isDarkMode ? 'light' : 'dark'} mode`;
    inverterButton.setAttribute('aria-label', message);
    inverterButton.setAttribute('title', message);
};

});
parcelRegister("1n4Kt", function(module, exports) {

$parcel$export(module.exports, "getLanguageCode", function () { return $0ffb9f60fdcbf817$export$bca6b946a784e234; });
$parcel$export(module.exports, "resolveLocale", function () { return $0ffb9f60fdcbf817$export$df9bcabe7f932e01; });
$parcel$export(module.exports, "localizeUrl", function () { return $0ffb9f60fdcbf817$export$65d83a3f6e8f873c; });
$parcel$export(module.exports, "nextLocale", function () { return $0ffb9f60fdcbf817$export$91cc145098d53c41; });

var $8ucNL = parcelRequire("8ucNL");
const $0ffb9f60fdcbf817$export$bca6b946a784e234 = ({ code: code })=>code.split('-')[0];
const $0ffb9f60fdcbf817$var$isProductionHost = (host)=>host === (0, $8ucNL.SITE_HOST) || host.endsWith(`.${(0, $8ucNL.SITE_HOST)}`);
const $0ffb9f60fdcbf817$var$byLanguageCode = (code)=>(0, $8ucNL.LOCALES).find((locale)=>$0ffb9f60fdcbf817$export$bca6b946a784e234(locale) === code);
const $0ffb9f60fdcbf817$export$df9bcabe7f932e01 = ()=>{
    const { host: host, hostname: hostname, pathname: pathname, search: search, hash: hash, protocol: protocol } = window.location;
    const [subdomain] = hostname.split('.');
    const subdomainLocale = $0ffb9f60fdcbf817$var$byLanguageCode(subdomain);
    const queryLocale = $0ffb9f60fdcbf817$var$byLanguageCode(new URLSearchParams(search).get('lang'));
    const [navigatorLanguage] = (window.navigator.language || '').split('-');
    const navigatorLocale = $0ffb9f60fdcbf817$var$byLanguageCode(navigatorLanguage);
    const defaultLocale = (0, $8ucNL.LOCALES).find((locale)=>locale.default);
    const locale = subdomainLocale || queryLocale || navigatorLocale || defaultLocale;
    let redirectTo = null;
    if (!subdomainLocale && $0ffb9f60fdcbf817$var$isProductionHost(host)) redirectTo = `${protocol}//${$0ffb9f60fdcbf817$export$bca6b946a784e234(locale)}.${0, $8ucNL.SITE_HOST}${pathname}${search}${hash}`;
    return {
        locale: locale,
        redirectTo: redirectTo
    };
};
const $0ffb9f60fdcbf817$export$65d83a3f6e8f873c = (url, fromLocale, toLocale)=>{
    const from = $0ffb9f60fdcbf817$export$bca6b946a784e234(fromLocale);
    const to = $0ffb9f60fdcbf817$export$bca6b946a784e234(toLocale);
    const subdomain = new RegExp(`^(https?:\\/\\/)${from}\\.`);
    if (subdomain.test(url)) return url.replace(subdomain, `$1${to}.`);
    const target = new URL(url, window.location.href);
    target.searchParams.set('lang', to);
    return target.toString();
};
const $0ffb9f60fdcbf817$export$91cc145098d53c41 = (locale)=>{
    const index = (0, $8ucNL.LOCALES).findIndex(({ code: code })=>code === locale.code);
    return (0, $8ucNL.LOCALES)[(index + 1) % (0, $8ucNL.LOCALES).length];
};

});
parcelRegister("8ucNL", function(module, exports) {

$parcel$export(module.exports, "FEATURED_ITEM_COUNT", function () { return $62db0e30fb9c3e4e$export$c65d8aafb3e339cc; });
$parcel$export(module.exports, "SITE_HOST", function () { return $62db0e30fb9c3e4e$export$628fc4a6d5533434; });
$parcel$export(module.exports, "LOCALES", function () { return $62db0e30fb9c3e4e$export$e49c1078bc46f17; });
$parcel$export(module.exports, "GTM_ID", function () { return $62db0e30fb9c3e4e$export$1e063e25369382bc; });
$parcel$export(module.exports, "LEGAL_PAGES", function () { return $62db0e30fb9c3e4e$export$8320cb9cba58aecf; });
$parcel$export(module.exports, "COOKIE_SETTINGS_LABEL", function () { return $62db0e30fb9c3e4e$export$506d905702cf6bab; });
$parcel$export(module.exports, "legalPageFromPath", function () { return $62db0e30fb9c3e4e$export$4895d68422648312; });
const $62db0e30fb9c3e4e$export$c65d8aafb3e339cc = 4;
const $62db0e30fb9c3e4e$export$628fc4a6d5533434 = 'hinterland.software';
const $62db0e30fb9c3e4e$export$e49c1078bc46f17 = [
    {
        code: 'en-US',
        name: 'English',
        default: true
    },
    {
        code: 'de',
        name: 'Deutsch',
        default: false
    }
];
const $62db0e30fb9c3e4e$export$1e063e25369382bc = 'GTM-NLJQ2ZDQ';
const $62db0e30fb9c3e4e$export$8320cb9cba58aecf = {
    impressum: {
        slug: {
            en: '/legal-notice',
            de: '/impressum'
        },
        titleKey: 'legal.impressum.title',
        contentKey: 'legal.impressum.content'
    },
    datenschutz: {
        slug: {
            en: '/privacy',
            de: '/datenschutz'
        },
        titleKey: 'legal.datenschutz.title',
        contentKey: 'legal.datenschutz.content'
    }
};
const $62db0e30fb9c3e4e$export$506d905702cf6bab = {
    en: 'Cookie settings',
    de: 'Cookie-Einstellungen'
};
const $62db0e30fb9c3e4e$export$4895d68422648312 = (pathname)=>{
    const clean = pathname.replace(/^\//, '').replace(/\/$/, '');
    const file = clean.match(/^legal\.(impressum|datenschutz)\.(?:en|de)\.html$/);
    if (file) return file[1];
    for (const [page, { slug: slug }] of Object.entries($62db0e30fb9c3e4e$export$8320cb9cba58aecf)){
        if (Object.values(slug).includes(`/${clean}`)) return page;
    }
    return null;
};

});


parcelRegister("bNTxO", function(module, exports) {

$parcel$export(module.exports, "escapeHtml", function () { return $55f42283ccc08b54$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "getItemUrl", function () { return $55f42283ccc08b54$export$f20638017d2565ce; });
// Helpers used by both the browser bundle and the Node prerender: no DOM,
// no extensionless imports.
const $55f42283ccc08b54$export$4cf11838cdc2a8a8 = (value)=>String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const $55f42283ccc08b54$var$DOMAIN = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/i;
const $55f42283ccc08b54$export$f20638017d2565ce = ({ url: url, heading: heading })=>{
    if (url) return url;
    const name = String(heading || '').trim();
    return $55f42283ccc08b54$var$DOMAIN.test(name) ? `https://${name}` : null;
};

});


parcelRegister("7CJkj", function(module, exports) {

$parcel$export(module.exports, "parseRichText", function () { return $58cf3df2bed0aa97$export$15ec9472ff2d721; });
$parcel$export(module.exports, "default", function () { return $58cf3df2bed0aa97$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "fetchMicrocopyOnly", function () { return $58cf3df2bed0aa97$export$151846fc38830761; });
$parcel$export(module.exports, "documentToPlainTextString", function () { return (parcelRequire("gaesL")).documentToPlainTextString; });

var $4sC9U = parcelRequire("4sC9U");
parcelRequire("8a7Cy");
var $chn5L = parcelRequire("chn5L");
var $hlstQ = parcelRequire("hlstQ");

var $ccVfB = parcelRequire("ccVfB");

var $bNTxO = parcelRequire("bNTxO");

var $gaesL = parcelRequire("gaesL");
const $58cf3df2bed0aa97$var$textOf = (node)=>(0, $bNTxO.escapeHtml)((node.content || []).map((c)=>c.value || '').join(''));
const $58cf3df2bed0aa97$var$fileOf = (node)=>node.data && node.data.target && node.data.target.fields ? node.data.target.fields.file : null;
// Link targets can be unpublished or deleted, in which case the API leaves
// them out of `includes` and the default renderers throw. These fall back to
// the visible text instead.
const $58cf3df2bed0aa97$var$renderNode = {
    [(0, $hlstQ.INLINES).ASSET_HYPERLINK]: (node)=>{
        const file = $58cf3df2bed0aa97$var$fileOf(node);
        return file ? `<a href="${(0, $bNTxO.escapeHtml)(file.url)}">${$58cf3df2bed0aa97$var$textOf(node)}</a>` : $58cf3df2bed0aa97$var$textOf(node);
    },
    [(0, $hlstQ.INLINES).ENTRY_HYPERLINK]: (node)=>$58cf3df2bed0aa97$var$textOf(node),
    [(0, $hlstQ.INLINES).EMBEDDED_ENTRY]: ()=>'',
    [(0, $chn5L.BLOCKS).EMBEDDED_ENTRY]: ()=>'',
    [(0, $chn5L.BLOCKS).EMBEDDED_ASSET]: (node)=>{
        const file = $58cf3df2bed0aa97$var$fileOf(node);
        if (!file || !/^image\//.test(file.contentType || '')) return '';
        const title = (0, $bNTxO.escapeHtml)(node.data.target.fields.title || '');
        return `<img src="${(0, $bNTxO.escapeHtml)(file.url)}" alt="${title}" loading="lazy">`;
    }
};
const $58cf3df2bed0aa97$export$15ec9472ff2d721 = (value)=>{
    if (!value) return '';
    return (0, $4sC9U.documentToHtmlString)(value, {
        renderNode: $58cf3df2bed0aa97$var$renderNode
    });
};
const $58cf3df2bed0aa97$var$cache = {
    microcopy: null,
    sections: null
};
var $58cf3df2bed0aa97$export$2e2bcd8739ae039 = ({ locale: locale }, options = {})=>{
    if ($58cf3df2bed0aa97$var$cache.microcopy && $58cf3df2bed0aa97$var$cache.sections) return Promise.resolve({
        ...$58cf3df2bed0aa97$var$cache,
        locale: locale
    });
    return Promise.all([
        (0, $ccVfB.fetchMicrocopy)(locale.code, options),
        (0, $ccVfB.fetchSections)(locale.code)
    ]).then(([microcopy, sections])=>{
        $58cf3df2bed0aa97$var$cache.microcopy = microcopy;
        $58cf3df2bed0aa97$var$cache.sections = sections;
        return {
            microcopy: microcopy,
            sections: sections,
            locale: locale
        };
    });
};
const $58cf3df2bed0aa97$export$151846fc38830761 = (locale)=>(0, $ccVfB.fetchMicrocopy)(locale.code);

});
parcelRegister("4sC9U", function(module, exports) {

$parcel$export(module.exports, "documentToHtmlString", function () { return $33f760844a7ff066$export$7baf571c7f59ce7c; }, function (v) { return $33f760844a7ff066$export$7baf571c7f59ce7c = v; });
var $33f760844a7ff066$export$7baf571c7f59ce7c;
'use strict';
parcelRequire("8a7Cy");
var $chn5L = parcelRequire("chn5L");
var $1VjU1 = parcelRequire("1VjU1");
var $hlstQ = parcelRequire("hlstQ");
var $cNCR3 = parcelRequire("cNCR3");

var $bUBBP = parcelRequire("bUBBP");
const $33f760844a7ff066$var$attributeValue = (value)=>`"${value.replace(/"/g, '&quot;')}"`;
const $33f760844a7ff066$var$defaultNodeRenderers = {
    [$chn5L.BLOCKS.PARAGRAPH]: (node, next)=>`<p>${next(node.content)}</p>`,
    [$chn5L.BLOCKS.HEADING_1]: (node, next)=>`<h1>${next(node.content)}</h1>`,
    [$chn5L.BLOCKS.HEADING_2]: (node, next)=>`<h2>${next(node.content)}</h2>`,
    [$chn5L.BLOCKS.HEADING_3]: (node, next)=>`<h3>${next(node.content)}</h3>`,
    [$chn5L.BLOCKS.HEADING_4]: (node, next)=>`<h4>${next(node.content)}</h4>`,
    [$chn5L.BLOCKS.HEADING_5]: (node, next)=>`<h5>${next(node.content)}</h5>`,
    [$chn5L.BLOCKS.HEADING_6]: (node, next)=>`<h6>${next(node.content)}</h6>`,
    [$chn5L.BLOCKS.EMBEDDED_ENTRY]: (node, next)=>`<div>${next(node.content)}</div>`,
    [$chn5L.BLOCKS.EMBEDDED_RESOURCE]: (node, next)=>`<div>${next(node.content)}</div>`,
    [$chn5L.BLOCKS.UL_LIST]: (node, next)=>`<ul>${next(node.content)}</ul>`,
    [$chn5L.BLOCKS.OL_LIST]: (node, next)=>`<ol>${next(node.content)}</ol>`,
    [$chn5L.BLOCKS.LIST_ITEM]: (node, next)=>`<li>${next(node.content)}</li>`,
    [$chn5L.BLOCKS.QUOTE]: (node, next)=>`<blockquote>${next(node.content)}</blockquote>`,
    [$chn5L.BLOCKS.HR]: ()=>'<hr/>',
    [$chn5L.BLOCKS.TABLE]: (node, next)=>`<table>${next(node.content)}</table>`,
    [$chn5L.BLOCKS.TABLE_ROW]: (node, next)=>`<tr>${next(node.content)}</tr>`,
    [$chn5L.BLOCKS.TABLE_HEADER_CELL]: (node, next)=>`<th>${next(node.content)}</th>`,
    [$chn5L.BLOCKS.TABLE_CELL]: (node, next)=>`<td>${next(node.content)}</td>`,
    [$hlstQ.INLINES.ASSET_HYPERLINK]: (node)=>$33f760844a7ff066$var$defaultInline($hlstQ.INLINES.ASSET_HYPERLINK, node),
    [$hlstQ.INLINES.ENTRY_HYPERLINK]: (node)=>$33f760844a7ff066$var$defaultInline($hlstQ.INLINES.ENTRY_HYPERLINK, node),
    [$hlstQ.INLINES.RESOURCE_HYPERLINK]: (node)=>$33f760844a7ff066$var$defaultInlineResource($hlstQ.INLINES.RESOURCE_HYPERLINK, node),
    [$hlstQ.INLINES.EMBEDDED_ENTRY]: (node)=>$33f760844a7ff066$var$defaultInline($hlstQ.INLINES.EMBEDDED_ENTRY, node),
    [$hlstQ.INLINES.EMBEDDED_RESOURCE]: (node)=>$33f760844a7ff066$var$defaultInlineResource($hlstQ.INLINES.EMBEDDED_RESOURCE, node),
    [$hlstQ.INLINES.HYPERLINK]: (node, next)=>{
        const href = typeof node.data.uri === 'string' ? node.data.uri : '';
        return `<a href=${$33f760844a7ff066$var$attributeValue(href)}>${next(node.content)}</a>`;
    }
};
const $33f760844a7ff066$var$defaultMarkRenderers = {
    [$cNCR3.MARKS.BOLD]: (text)=>`<b>${text}</b>`,
    [$cNCR3.MARKS.ITALIC]: (text)=>`<i>${text}</i>`,
    [$cNCR3.MARKS.UNDERLINE]: (text)=>`<u>${text}</u>`,
    [$cNCR3.MARKS.CODE]: (text)=>`<code>${text}</code>`,
    [$cNCR3.MARKS.SUPERSCRIPT]: (text)=>`<sup>${text}</sup>`,
    [$cNCR3.MARKS.SUBSCRIPT]: (text)=>`<sub>${text}</sub>`,
    [$cNCR3.MARKS.STRIKETHROUGH]: (text)=>`<s>${text}</s>`
};
const $33f760844a7ff066$var$defaultInline = (type, node)=>`<span>type: ${$bUBBP(type)} id: ${$bUBBP(node.data.target.sys.id)}</span>`;
const $33f760844a7ff066$var$defaultInlineResource = (type, node)=>`<span>type: ${$bUBBP(type)} urn: ${$bUBBP(node.data.target.sys.urn)}</span>`;
function $33f760844a7ff066$var$documentToHtmlString(richTextDocument, options = {}) {
    if (!richTextDocument || !richTextDocument.content) return '';
    let processedDocument = richTextDocument;
    if (options.stripEmptyTrailingParagraph) processedDocument = $1VjU1.stripEmptyTrailingParagraphFromDocument(richTextDocument);
    return $33f760844a7ff066$var$nodeListToHtmlString(processedDocument.content, {
        renderNode: {
            ...$33f760844a7ff066$var$defaultNodeRenderers,
            ...options.renderNode
        },
        renderMark: {
            ...$33f760844a7ff066$var$defaultMarkRenderers,
            ...options.renderMark
        },
        preserveWhitespace: options.preserveWhitespace
    });
}
function $33f760844a7ff066$var$nodeListToHtmlString(nodes, { renderNode: renderNode, renderMark: renderMark, preserveWhitespace: preserveWhitespace }) {
    return nodes.map((node)=>$33f760844a7ff066$var$nodeToHtmlString(node, {
            renderNode: renderNode,
            renderMark: renderMark,
            preserveWhitespace: preserveWhitespace
        })).join('');
}
function $33f760844a7ff066$var$nodeToHtmlString(node, { renderNode: renderNode, renderMark: renderMark, preserveWhitespace: preserveWhitespace }) {
    if ($1VjU1.isText(node)) {
        let nodeValue = $bUBBP(node.value);
        if (preserveWhitespace) nodeValue = nodeValue.replace(/\n/g, '<br/>').replace(/ {2,}/g, (match)=>'&nbsp;'.repeat(match.length));
        if (node.marks.length > 0) return node.marks.reduce((value, mark)=>{
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
        return nodeValue;
    } else {
        const nextNode = (nodes)=>$33f760844a7ff066$var$nodeListToHtmlString(nodes, {
                renderMark: renderMark,
                renderNode: renderNode,
                preserveWhitespace: preserveWhitespace
            });
        if (!node.nodeType || !renderNode[node.nodeType]) return '';
        return renderNode[node.nodeType](node, nextNode);
    }
}
$33f760844a7ff066$export$7baf571c7f59ce7c = $33f760844a7ff066$var$documentToHtmlString;

});
parcelRegister("8a7Cy", function(module, exports) {

$parcel$export(module.exports, "BLOCKS", function () { return (parcelRequire("chn5L")).BLOCKS; });
$parcel$export(module.exports, "INLINES", function () { return (parcelRequire("hlstQ")).INLINES; });
$parcel$export(module.exports, "MARKS", function () { return (parcelRequire("cNCR3")).MARKS; });
$parcel$export(module.exports, "helpers", function () { return (parcelRequire("1VjU1")); });

var $chn5L = parcelRequire("chn5L");

var $hlstQ = parcelRequire("hlstQ");

var $cNCR3 = parcelRequire("cNCR3");
parcelRequire("64wGn");
parcelRequire("fBQiw");
parcelRequire("dV0eb");

var $aWIUb = parcelRequire("aWIUb");

var $1VjU1 = parcelRequire("1VjU1");

var $aVfyi = parcelRequire("aVfyi");

});
parcelRegister("chn5L", function(module, exports) {

$parcel$export(module.exports, "BLOCKS", function () { return $3c94accf5ca25ac6$export$4473561af957c5c7; });
var $3c94accf5ca25ac6$export$4473561af957c5c7 = /*#__PURE__*/ function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
    return BLOCKS;
}({});

});

parcelRegister("hlstQ", function(module, exports) {

$parcel$export(module.exports, "INLINES", function () { return $5e108e09ed895245$export$6dca1cbf5d592fbd; });
var $5e108e09ed895245$export$6dca1cbf5d592fbd = /*#__PURE__*/ function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
    return INLINES;
}({});

});

parcelRegister("cNCR3", function(module, exports) {

$parcel$export(module.exports, "MARKS", function () { return $8f22969afc2de83a$export$c85f128c9305332e; });
var $8f22969afc2de83a$export$c85f128c9305332e = /*#__PURE__*/ function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
    return MARKS;
}({});

});

parcelRegister("64wGn", function(module, exports) {

$parcel$export(module.exports, "TOP_LEVEL_BLOCKS", function () { return $f366830aeaf3434a$export$ba32543429ed7e1c; });
$parcel$export(module.exports, "LIST_ITEM_BLOCKS", function () { return $f366830aeaf3434a$export$f164f8df1f226ed8; });
$parcel$export(module.exports, "CONTAINERS", function () { return $f366830aeaf3434a$export$f31e81340f60ac4f; });

var $chn5L = parcelRequire("chn5L");

var $hlstQ = parcelRequire("hlstQ");

var $cNCR3 = parcelRequire("cNCR3");
function $f366830aeaf3434a$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f366830aeaf3434a$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $f366830aeaf3434a$var$_array_like_to_array(arr);
}
function $f366830aeaf3434a$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f366830aeaf3434a$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f366830aeaf3434a$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f366830aeaf3434a$var$_to_consumable_array(arr) {
    return $f366830aeaf3434a$var$_array_without_holes(arr) || $f366830aeaf3434a$var$_iterable_to_array(arr) || $f366830aeaf3434a$var$_unsupported_iterable_to_array(arr) || $f366830aeaf3434a$var$_non_iterable_spread();
}
function $f366830aeaf3434a$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f366830aeaf3434a$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f366830aeaf3434a$var$_array_like_to_array(o, minLen);
}
var $f366830aeaf3434a$export$ba32543429ed7e1c = [
    (0, $chn5L.BLOCKS).PARAGRAPH,
    (0, $chn5L.BLOCKS).HEADING_1,
    (0, $chn5L.BLOCKS).HEADING_2,
    (0, $chn5L.BLOCKS).HEADING_3,
    (0, $chn5L.BLOCKS).HEADING_4,
    (0, $chn5L.BLOCKS).HEADING_5,
    (0, $chn5L.BLOCKS).HEADING_6,
    (0, $chn5L.BLOCKS).OL_LIST,
    (0, $chn5L.BLOCKS).UL_LIST,
    (0, $chn5L.BLOCKS).HR,
    (0, $chn5L.BLOCKS).QUOTE,
    (0, $chn5L.BLOCKS).EMBEDDED_ENTRY,
    (0, $chn5L.BLOCKS).EMBEDDED_ASSET,
    (0, $chn5L.BLOCKS).EMBEDDED_RESOURCE,
    (0, $chn5L.BLOCKS).TABLE
];
var $f366830aeaf3434a$export$f164f8df1f226ed8 = [
    (0, $chn5L.BLOCKS).PARAGRAPH,
    (0, $chn5L.BLOCKS).HEADING_1,
    (0, $chn5L.BLOCKS).HEADING_2,
    (0, $chn5L.BLOCKS).HEADING_3,
    (0, $chn5L.BLOCKS).HEADING_4,
    (0, $chn5L.BLOCKS).HEADING_5,
    (0, $chn5L.BLOCKS).HEADING_6,
    (0, $chn5L.BLOCKS).OL_LIST,
    (0, $chn5L.BLOCKS).UL_LIST,
    (0, $chn5L.BLOCKS).HR,
    (0, $chn5L.BLOCKS).QUOTE,
    (0, $chn5L.BLOCKS).EMBEDDED_ENTRY,
    (0, $chn5L.BLOCKS).EMBEDDED_ASSET,
    (0, $chn5L.BLOCKS).EMBEDDED_RESOURCE
];
var $f366830aeaf3434a$export$61dc594370225b3 = [
    (0, $chn5L.BLOCKS).TABLE,
    (0, $chn5L.BLOCKS).TABLE_ROW,
    (0, $chn5L.BLOCKS).TABLE_CELL,
    (0, $chn5L.BLOCKS).TABLE_HEADER_CELL
];
var $f366830aeaf3434a$export$85f9856e66f16aa5 = [
    (0, $chn5L.BLOCKS).HR,
    (0, $chn5L.BLOCKS).EMBEDDED_ENTRY,
    (0, $chn5L.BLOCKS).EMBEDDED_ASSET,
    (0, $chn5L.BLOCKS).EMBEDDED_RESOURCE
];
var $f366830aeaf3434a$var$_obj;
var $f366830aeaf3434a$export$f31e81340f60ac4f = ($f366830aeaf3434a$var$_obj = {}, $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).OL_LIST, [
    (0, $chn5L.BLOCKS).LIST_ITEM
]), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).UL_LIST, [
    (0, $chn5L.BLOCKS).LIST_ITEM
]), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).LIST_ITEM, $f366830aeaf3434a$export$f164f8df1f226ed8), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).QUOTE, [
    (0, $chn5L.BLOCKS).PARAGRAPH
]), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).TABLE, [
    (0, $chn5L.BLOCKS).TABLE_ROW
]), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).TABLE_ROW, [
    (0, $chn5L.BLOCKS).TABLE_CELL,
    (0, $chn5L.BLOCKS).TABLE_HEADER_CELL
]), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).TABLE_CELL, [
    (0, $chn5L.BLOCKS).PARAGRAPH,
    (0, $chn5L.BLOCKS).UL_LIST,
    (0, $chn5L.BLOCKS).OL_LIST
]), $f366830aeaf3434a$var$_define_property($f366830aeaf3434a$var$_obj, (0, $chn5L.BLOCKS).TABLE_HEADER_CELL, [
    (0, $chn5L.BLOCKS).PARAGRAPH
]), $f366830aeaf3434a$var$_obj);
var $f366830aeaf3434a$export$7b02abc60d9af577 = [
    (0, $chn5L.BLOCKS).HEADING_1,
    (0, $chn5L.BLOCKS).HEADING_2,
    (0, $chn5L.BLOCKS).HEADING_3,
    (0, $chn5L.BLOCKS).HEADING_4,
    (0, $chn5L.BLOCKS).HEADING_5,
    (0, $chn5L.BLOCKS).HEADING_6
];
var $f366830aeaf3434a$export$33c1f54ccb4cc9b7 = [
    (0, $chn5L.BLOCKS).PARAGRAPH
].concat($f366830aeaf3434a$var$_to_consumable_array($f366830aeaf3434a$export$7b02abc60d9af577));
var $f366830aeaf3434a$export$f8a6793e9df3d55d = [
    (0, $chn5L.BLOCKS).DOCUMENT,
    (0, $chn5L.BLOCKS).PARAGRAPH,
    (0, $chn5L.BLOCKS).HEADING_1,
    (0, $chn5L.BLOCKS).HEADING_2,
    (0, $chn5L.BLOCKS).HEADING_3,
    (0, $chn5L.BLOCKS).HEADING_4,
    (0, $chn5L.BLOCKS).HEADING_5,
    (0, $chn5L.BLOCKS).HEADING_6,
    (0, $chn5L.BLOCKS).OL_LIST,
    (0, $chn5L.BLOCKS).UL_LIST,
    (0, $chn5L.BLOCKS).LIST_ITEM,
    (0, $chn5L.BLOCKS).HR,
    (0, $chn5L.BLOCKS).QUOTE,
    (0, $chn5L.BLOCKS).EMBEDDED_ENTRY,
    (0, $chn5L.BLOCKS).EMBEDDED_ASSET,
    (0, $hlstQ.INLINES).HYPERLINK,
    (0, $hlstQ.INLINES).ENTRY_HYPERLINK,
    (0, $hlstQ.INLINES).ASSET_HYPERLINK,
    (0, $hlstQ.INLINES).EMBEDDED_ENTRY,
    'text'
];
var $f366830aeaf3434a$export$d8b073923a26e49d = [
    (0, $cNCR3.MARKS).BOLD,
    (0, $cNCR3.MARKS).CODE,
    (0, $cNCR3.MARKS).ITALIC,
    (0, $cNCR3.MARKS).UNDERLINE
];

});

parcelRegister("fBQiw", function(module, exports) {

});

parcelRegister("dV0eb", function(module, exports) {

});

parcelRegister("aWIUb", function(module, exports) {

var $chn5L = parcelRequire("chn5L");
var $added46b1cfb3969$export$e5cde5f1d56fabad = {
    nodeType: (0, $chn5L.BLOCKS).DOCUMENT,
    data: {},
    content: [
        {
            nodeType: (0, $chn5L.BLOCKS).PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};

});

parcelRegister("1VjU1", function(module, exports) {

$parcel$export(module.exports, "isInline", function () { return $d33bcb446df73298$export$ff307ae11ac2408e; });
$parcel$export(module.exports, "isBlock", function () { return $d33bcb446df73298$export$de5a9e42c1dff8da; });
$parcel$export(module.exports, "isText", function () { return $d33bcb446df73298$export$1879817ac5c922b7; });
$parcel$export(module.exports, "isEmptyParagraph", function () { return $d33bcb446df73298$export$b648602b09795358; });
$parcel$export(module.exports, "stripEmptyTrailingParagraphFromDocument", function () { return $d33bcb446df73298$export$a26c6fe6009781cb; });

var $chn5L = parcelRequire("chn5L");

var $hlstQ = parcelRequire("hlstQ");
function $d33bcb446df73298$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d33bcb446df73298$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $d33bcb446df73298$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
function $d33bcb446df73298$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d33bcb446df73298$var$_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d33bcb446df73298$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function $d33bcb446df73298$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $d33bcb446df73298$var$hasValue(obj, value) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (value === obj[key]) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return false;
}
function $d33bcb446df73298$export$ff307ae11ac2408e(node) {
    return $d33bcb446df73298$var$hasValue((0, $hlstQ.INLINES), node.nodeType);
}
function $d33bcb446df73298$export$de5a9e42c1dff8da(node) {
    return $d33bcb446df73298$var$hasValue((0, $chn5L.BLOCKS), node.nodeType);
}
function $d33bcb446df73298$export$1879817ac5c922b7(node) {
    return node.nodeType === 'text';
}
function $d33bcb446df73298$export$b648602b09795358(node) {
    if (node.nodeType !== (0, $chn5L.BLOCKS).PARAGRAPH) return false;
    if (node.content.length !== 1) return false;
    var textNode = node.content[0];
    return textNode.nodeType === 'text' && textNode.value === '';
}
function $d33bcb446df73298$var$isValidDocument(document) {
    return document != null && (typeof document === "undefined" ? "undefined" : $d33bcb446df73298$var$_type_of(document)) === 'object' && 'content' in document && Array.isArray(document.content);
}
var $d33bcb446df73298$var$MIN_NODES_FOR_STRIPPING = 2;
function $d33bcb446df73298$export$a26c6fe6009781cb(document) {
    if (!$d33bcb446df73298$var$isValidDocument(document) || document.content.length < $d33bcb446df73298$var$MIN_NODES_FOR_STRIPPING) return document;
    var lastNode = document.content[document.content.length - 1];
    if ($d33bcb446df73298$export$b648602b09795358(lastNode)) return $d33bcb446df73298$var$_object_spread_props($d33bcb446df73298$var$_object_spread({}, document), {
        content: document.content.slice(0, -1)
    });
    return document;
}

});

parcelRegister("aVfyi", function(module, exports) {

var $chn5L = parcelRequire("chn5L");

var $hlstQ = parcelRequire("hlstQ");

var $64wGn = parcelRequire("64wGn");

var $6VggO = parcelRequire("6VggO");

var $j3GN3 = parcelRequire("j3GN3");

var $81YbO = parcelRequire("81YbO");

var $hFFNv = parcelRequire("hFFNv");
function $567ddca4519b71a6$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $567ddca4519b71a6$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $567ddca4519b71a6$var$_array_like_to_array(arr);
}
function $567ddca4519b71a6$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $567ddca4519b71a6$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $567ddca4519b71a6$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $567ddca4519b71a6$var$_to_consumable_array(arr) {
    return $567ddca4519b71a6$var$_array_without_holes(arr) || $567ddca4519b71a6$var$_iterable_to_array(arr) || $567ddca4519b71a6$var$_unsupported_iterable_to_array(arr) || $567ddca4519b71a6$var$_non_iterable_spread();
}
function $567ddca4519b71a6$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $567ddca4519b71a6$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $567ddca4519b71a6$var$_array_like_to_array(o, minLen);
}
var $567ddca4519b71a6$var$assertInlineOrText = (0, $j3GN3.assert)($567ddca4519b71a6$var$_to_consumable_array(Object.values((0, $hlstQ.INLINES))).concat([
    'text'
]).sort());
var $567ddca4519b71a6$var$assertList = (0, $j3GN3.assert)([
    (0, $chn5L.BLOCKS).LIST_ITEM
]);
var $567ddca4519b71a6$var$assertVoidEntryLink = (0, $j3GN3.assertLink)('Entry', (0, $j3GN3.VOID_CONTENT));
var $567ddca4519b71a6$var$assertTableCell = (0, $j3GN3.assert)(function() {
    return {
        nodeTypes: [
            (0, $chn5L.BLOCKS).PARAGRAPH
        ],
        min: 1
    };
}, function(data, path) {
    var $ = new (0, $6VggO.ObjectAssertion)(data, path);
    $.noAdditionalProperties([
        'colspan',
        'rowspan'
    ]);
    $.number('colspan', true);
    $.number('rowspan', true);
    return $.errors;
});
var $567ddca4519b71a6$var$_obj;
var $567ddca4519b71a6$var$nodeValidator = ($567ddca4519b71a6$var$_obj = {}, $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).DOCUMENT, (0, $j3GN3.assert)((0, $64wGn.TOP_LEVEL_BLOCKS))), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).PARAGRAPH, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HEADING_1, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HEADING_2, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HEADING_3, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HEADING_4, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HEADING_5, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HEADING_6, $567ddca4519b71a6$var$assertInlineOrText), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).QUOTE, (0, $j3GN3.assert)((0, $64wGn.CONTAINERS)[(0, $chn5L.BLOCKS).QUOTE])), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).EMBEDDED_ENTRY, $567ddca4519b71a6$var$assertVoidEntryLink), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).EMBEDDED_ASSET, (0, $j3GN3.assertLink)('Asset', (0, $j3GN3.VOID_CONTENT))), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).EMBEDDED_RESOURCE, (0, $j3GN3.assertLink)('Contentful:Entry', (0, $j3GN3.VOID_CONTENT))), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).HR, (0, $j3GN3.assert)((0, $j3GN3.VOID_CONTENT))), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).OL_LIST, $567ddca4519b71a6$var$assertList), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).UL_LIST, $567ddca4519b71a6$var$assertList), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).LIST_ITEM, (0, $j3GN3.assert)($567ddca4519b71a6$var$_to_consumable_array((0, $64wGn.LIST_ITEM_BLOCKS)).sort())), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).TABLE, (0, $j3GN3.assert)(function() {
    return {
        nodeTypes: [
            (0, $chn5L.BLOCKS).TABLE_ROW
        ],
        min: 1
    };
})), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).TABLE_ROW, (0, $j3GN3.assert)(function() {
    return {
        nodeTypes: [
            (0, $chn5L.BLOCKS).TABLE_CELL,
            (0, $chn5L.BLOCKS).TABLE_HEADER_CELL
        ],
        min: 1
    };
})), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).TABLE_CELL, $567ddca4519b71a6$var$assertTableCell), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $chn5L.BLOCKS).TABLE_HEADER_CELL, $567ddca4519b71a6$var$assertTableCell), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $hlstQ.INLINES).HYPERLINK, new (0, $j3GN3.HyperLinkAssertion)()), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $hlstQ.INLINES).EMBEDDED_ENTRY, $567ddca4519b71a6$var$assertVoidEntryLink), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $hlstQ.INLINES).EMBEDDED_RESOURCE, (0, $j3GN3.assertLink)('Contentful:Entry', (0, $j3GN3.VOID_CONTENT))), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $hlstQ.INLINES).ENTRY_HYPERLINK, (0, $j3GN3.assertLink)('Entry', [
    'text'
])), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $hlstQ.INLINES).ASSET_HYPERLINK, (0, $j3GN3.assertLink)('Asset', [
    'text'
])), $567ddca4519b71a6$var$_define_property($567ddca4519b71a6$var$_obj, (0, $hlstQ.INLINES).RESOURCE_HYPERLINK, (0, $j3GN3.assertLink)('Contentful:Entry', [
    'text'
])), $567ddca4519b71a6$var$_obj);
function $567ddca4519b71a6$var$validateNode(node, path) {
    if (node.nodeType === 'text') return (0, $hFFNv.assertText)(node, path);
    var errors = $567ddca4519b71a6$var$nodeValidator[node.nodeType].assert(node, path);
    if (errors.length > 0) return errors;
    var $ = new (0, $6VggO.ObjectAssertion)(node, path);
    $.each('content', function(item, path) {
        return $567ddca4519b71a6$var$validateNode(item, path);
    });
    return $.errors;
}
var $567ddca4519b71a6$export$1ee7d3855fc41eb3 = function(document) {
    var path = new (0, $81YbO.Path)();
    var $ = new (0, $6VggO.ObjectAssertion)(document, path);
    if ($.object()) $.enum('nodeType', [
        (0, $chn5L.BLOCKS).DOCUMENT
    ]);
    if ($.errors.length > 0) return $.errors;
    return $567ddca4519b71a6$var$validateNode(document, path);
};

});
parcelRegister("6VggO", function(module, exports) {

$parcel$export(module.exports, "ObjectAssertion", function () { return $1cc50e752b152e7f$export$fca495f07e0ce5c5; });

var $eQMD8 = parcelRequire("eQMD8");

var $6BTVj = parcelRequire("6BTVj");
function $1cc50e752b152e7f$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1cc50e752b152e7f$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $1cc50e752b152e7f$var$_array_like_to_array(arr);
}
function $1cc50e752b152e7f$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1cc50e752b152e7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1cc50e752b152e7f$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $1cc50e752b152e7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1cc50e752b152e7f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1cc50e752b152e7f$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1cc50e752b152e7f$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1cc50e752b152e7f$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1cc50e752b152e7f$var$_to_consumable_array(arr) {
    return $1cc50e752b152e7f$var$_array_without_holes(arr) || $1cc50e752b152e7f$var$_iterable_to_array(arr) || $1cc50e752b152e7f$var$_unsupported_iterable_to_array(arr) || $1cc50e752b152e7f$var$_non_iterable_spread();
}
function $1cc50e752b152e7f$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1cc50e752b152e7f$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1cc50e752b152e7f$var$_array_like_to_array(o, minLen);
}
var $1cc50e752b152e7f$export$fca495f07e0ce5c5 = /*#__PURE__*/ function() {
    "use strict";
    function ObjectAssertion(obj, path) {
        var _this = this;
        var _this1 = this;
        $1cc50e752b152e7f$var$_class_call_check(this, ObjectAssertion);
        $1cc50e752b152e7f$var$_define_property(this, "obj", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "path", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "_errors", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "catch", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "exists", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "object", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "string", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "number", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "array", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "enum", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "empty", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "minLength", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "noAdditionalProperties", void 0);
        $1cc50e752b152e7f$var$_define_property(this, "each", void 0);
        this.obj = obj;
        this.path = path;
        this._errors = [];
        this.catch = function() {
            for(var _len = arguments.length, errors = new Array(_len), _key = 0; _key < _len; _key++)errors[_key] = arguments[_key];
            var _this__errors;
            (_this__errors = _this1._errors).push.apply(_this__errors, $1cc50e752b152e7f$var$_to_consumable_array(errors));
        };
        this.exists = function(key) {
            if (key in _this.obj) return true;
            _this.catch((0, $6BTVj.requiredPropertyError)({
                property: key,
                path: _this.path.of(key)
            }));
            return false;
        };
        this.object = function(key) {
            var value = key ? _this.obj[key] : _this.obj;
            if (key) {
                if (!_this.exists(key)) return false;
            }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eQMD8)))(value)) return true;
            var _$path = key ? _this.path.of(key) : _this.path;
            var _ref;
            var property = (_ref = key !== null && key !== void 0 ? key : _this.path.last()) !== null && _ref !== void 0 ? _ref : 'value';
            _this.catch((0, $6BTVj.typeMismatchError)({
                typeName: 'Object',
                property: property,
                path: _$path,
                value: value
            }));
            return false;
        };
        this.string = function(key) {
            var value = _this.obj[key];
            if (key && !_this.exists(key)) return false;
            if (typeof value === 'string') return true;
            _this.catch((0, $6BTVj.typeMismatchError)({
                typeName: 'String',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        this.number = function(key, optional) {
            var value = _this.obj[key];
            if (optional && !(key in _this.obj)) return true;
            if (!_this.exists(key)) return false;
            if (typeof value === 'number' && !Number.isNaN(value)) return true;
            _this.catch((0, $6BTVj.typeMismatchError)({
                typeName: 'Number',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        this.array = function(key) {
            var value = _this.obj[key];
            if (key && !_this.exists(key)) return false;
            if (Array.isArray(value)) return true;
            _this.catch((0, $6BTVj.typeMismatchError)({
                typeName: 'Array',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        this.enum = function(key, expected) {
            var value = _this.obj[key];
            if (typeof value === 'string' && expected.includes(value)) return true;
            _this.catch((0, $6BTVj.enumError)({
                expected: expected,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        this.empty = function(key) {
            if (!_this.array(key)) return false;
            var value = _this.obj[key];
            if (value.length === 0) return true;
            _this.catch((0, $6BTVj.maxSizeError)({
                max: 0,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        this.minLength = function(key, min) {
            if (!_this.array(key)) return false;
            var value = _this.obj[key];
            if (value.length >= min) return true;
            _this.catch((0, $6BTVj.minSizeError)({
                min: min,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        this.noAdditionalProperties = function(properties) {
            var unknowns = Object.keys(_this.obj).sort().filter(function(key) {
                return !properties.includes(key);
            });
            unknowns.forEach(function(property) {
                return _this.catch((0, $6BTVj.unknownPropertyError)({
                    property: property,
                    path: _this.path.of(property)
                }));
            });
            return unknowns.length === 0;
        };
        this.each = function(key, assert) {
            if (!_this.array(key)) return;
            var value = _this.obj[key];
            var foundErrors = false;
            value.forEach(function(item, index) {
                if (foundErrors) return;
                var errors = assert(item, _this.path.of(key).of(index));
                if (errors.length > 0) foundErrors = true;
                _this.catch.apply(_this, $1cc50e752b152e7f$var$_to_consumable_array(errors));
            });
        };
    }
    $1cc50e752b152e7f$var$_create_class(ObjectAssertion, [
        {
            key: "errors",
            get: function get() {
                var _this = this;
                var serializeError = function(error) {
                    return JSON.stringify({
                        details: error.details,
                        path: error.path
                    });
                };
                return this._errors.filter(function(error, index) {
                    return _this._errors.findIndex(function(step) {
                        return serializeError(error) === serializeError(step);
                    }) === index;
                });
            }
        }
    ]);
    return ObjectAssertion;
}();

});
parcelRegister("eQMD8", function(module, exports) {
'use strict';
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

});

parcelRegister("6BTVj", function(module, exports) {

$parcel$export(module.exports, "typeMismatchError", function () { return $0c73d77022f91dcf$export$6da4e62baca17b1; });
$parcel$export(module.exports, "minSizeError", function () { return $0c73d77022f91dcf$export$7cdc82382df1fb23; });
$parcel$export(module.exports, "maxSizeError", function () { return $0c73d77022f91dcf$export$b58b7443e10ac68d; });
$parcel$export(module.exports, "enumError", function () { return $0c73d77022f91dcf$export$5cafcd63d84057d5; });
$parcel$export(module.exports, "unknownPropertyError", function () { return $0c73d77022f91dcf$export$86be65c29262b4c4; });
$parcel$export(module.exports, "requiredPropertyError", function () { return $0c73d77022f91dcf$export$93d885a577569a80; });
function $0c73d77022f91dcf$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0c73d77022f91dcf$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $0c73d77022f91dcf$var$_array_like_to_array(arr);
}
function $0c73d77022f91dcf$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0c73d77022f91dcf$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c73d77022f91dcf$var$_to_consumable_array(arr) {
    return $0c73d77022f91dcf$var$_array_without_holes(arr) || $0c73d77022f91dcf$var$_iterable_to_array(arr) || $0c73d77022f91dcf$var$_unsupported_iterable_to_array(arr) || $0c73d77022f91dcf$var$_non_iterable_spread();
}
function $0c73d77022f91dcf$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0c73d77022f91dcf$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0c73d77022f91dcf$var$_array_like_to_array(o, minLen);
}
var $0c73d77022f91dcf$export$6da4e62baca17b1 = function(param) {
    var path = param.path, property = param.property, typeName = param.typeName, value = param.value;
    return {
        details: 'The type of "'.concat(property, '" is incorrect, expected type: ').concat(typeName),
        name: 'type',
        path: path.toArray(),
        type: typeName,
        value: value
    };
};
var $0c73d77022f91dcf$export$7cdc82382df1fb23 = function(param) {
    var min = param.min, value = param.value, path = param.path;
    return {
        name: 'size',
        min: min,
        path: path.toArray(),
        details: "Size must be at least ".concat(min),
        value: value
    };
};
var $0c73d77022f91dcf$export$b58b7443e10ac68d = function(param) {
    var max = param.max, value = param.value, path = param.path;
    return {
        name: 'size',
        max: max,
        path: path.toArray(),
        details: "Size must be at most ".concat(max),
        value: value
    };
};
var $0c73d77022f91dcf$export$5cafcd63d84057d5 = function(param) {
    var expected = param.expected, value = param.value, path = param.path;
    return {
        details: "Value must be one of expected values",
        name: 'in',
        expected: $0c73d77022f91dcf$var$_to_consumable_array(expected).sort(),
        path: path.toArray(),
        value: value
    };
};
var $0c73d77022f91dcf$export$86be65c29262b4c4 = function(param) {
    var property = param.property, path = param.path;
    return {
        details: 'The property "'.concat(property, '" is not expected'),
        name: 'unexpected',
        path: path.toArray()
    };
};
var $0c73d77022f91dcf$export$93d885a577569a80 = function(param) {
    var property = param.property, path = param.path;
    return {
        details: 'The property "'.concat(property, '" is required here'),
        name: 'required',
        path: path.toArray()
    };
};

});


parcelRegister("j3GN3", function(module, exports) {

$parcel$export(module.exports, "VOID_CONTENT", function () { return $51c7c8498af7e957$export$f591338d98dad71a; });
$parcel$export(module.exports, "HyperLinkAssertion", function () { return $51c7c8498af7e957$export$9115c851c20595ed; });
$parcel$export(module.exports, "assert", function () { return $51c7c8498af7e957$export$a7a9523472993e97; });
$parcel$export(module.exports, "assertLink", function () { return $51c7c8498af7e957$export$b0de494632252d30; });

var $6VggO = parcelRequire("6VggO");
function $51c7c8498af7e957$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $51c7c8498af7e957$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $51c7c8498af7e957$var$_array_like_to_array(arr);
}
function $51c7c8498af7e957$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $51c7c8498af7e957$var$_call_super(_this, derived, args) {
    derived = $51c7c8498af7e957$var$_get_prototype_of(derived);
    return $51c7c8498af7e957$var$_possible_constructor_return(_this, $51c7c8498af7e957$var$_is_native_reflect_construct() ? Reflect.construct(derived, args || [], $51c7c8498af7e957$var$_get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function $51c7c8498af7e957$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $51c7c8498af7e957$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $51c7c8498af7e957$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $51c7c8498af7e957$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $51c7c8498af7e957$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $51c7c8498af7e957$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $51c7c8498af7e957$var$_get_prototype_of(o) {
    $51c7c8498af7e957$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $51c7c8498af7e957$var$_get_prototype_of(o);
}
function $51c7c8498af7e957$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $51c7c8498af7e957$var$_set_prototype_of(subClass, superClass);
}
function $51c7c8498af7e957$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $51c7c8498af7e957$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51c7c8498af7e957$var$_possible_constructor_return(self, call) {
    if (call && ($51c7c8498af7e957$var$_type_of(call) === "object" || typeof call === "function")) return call;
    return $51c7c8498af7e957$var$_assert_this_initialized(self);
}
function $51c7c8498af7e957$var$_set_prototype_of(o, p) {
    $51c7c8498af7e957$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $51c7c8498af7e957$var$_set_prototype_of(o, p);
}
function $51c7c8498af7e957$var$_to_consumable_array(arr) {
    return $51c7c8498af7e957$var$_array_without_holes(arr) || $51c7c8498af7e957$var$_iterable_to_array(arr) || $51c7c8498af7e957$var$_unsupported_iterable_to_array(arr) || $51c7c8498af7e957$var$_non_iterable_spread();
}
function $51c7c8498af7e957$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $51c7c8498af7e957$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $51c7c8498af7e957$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $51c7c8498af7e957$var$_array_like_to_array(o, minLen);
}
function $51c7c8498af7e957$var$_is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($51c7c8498af7e957$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var $51c7c8498af7e957$export$f591338d98dad71a = [];
var $51c7c8498af7e957$export$ec7e084baa688f3d = /*#__PURE__*/ function() {
    "use strict";
    function NodeAssertion(contentRule, validateData) {
        $51c7c8498af7e957$var$_class_call_check(this, NodeAssertion);
        $51c7c8498af7e957$var$_define_property(this, "contentRule", void 0);
        $51c7c8498af7e957$var$_define_property(this, "validateData", void 0);
        this.contentRule = contentRule;
        this.validateData = validateData;
    }
    $51c7c8498af7e957$var$_create_class(NodeAssertion, [
        {
            key: "assert",
            value: function assert(node, path) {
                var $ = new (0, $6VggO.ObjectAssertion)(node, path);
                if (!$.object()) return $.errors;
                $.noAdditionalProperties([
                    'nodeType',
                    'data',
                    'content'
                ]);
                var _ref = Array.isArray(this.contentRule) ? {
                    nodeTypes: this.contentRule
                } : this.contentRule(node, path), nodeTypes = _ref.nodeTypes, _ref_min = _ref.min, min = _ref_min === void 0 ? 0 : _ref_min;
                if (nodeTypes.length === 0 && min > 0) throw new Error("Invalid content rule. Cannot have enforce a 'min' of ".concat(min, " with no nodeTypes"));
                $.minLength('content', min);
                if (nodeTypes.length === 0) $.empty('content');
                else $.each('content', function(item, path) {
                    var item$ = new (0, $6VggO.ObjectAssertion)(item, path);
                    if (!item$.object()) return item$.errors;
                    item$.enum('nodeType', nodeTypes);
                    return item$.errors;
                });
                if ($.object('data')) {
                    var _$;
                    var _this_validateData, _this;
                    var _this_validateData1;
                    var dataErrors = (_this_validateData1 = (_this_validateData = (_this = this).validateData) === null || _this_validateData === void 0 ? void 0 : _this_validateData.call(_this, node.data, path.of('data'))) !== null && _this_validateData1 !== void 0 ? _this_validateData1 : [];
                    (_$ = $).catch.apply(_$, $51c7c8498af7e957$var$_to_consumable_array(dataErrors));
                }
                return $.errors;
            }
        }
    ]);
    return NodeAssertion;
}();
var $51c7c8498af7e957$export$f841b7ad0115c5ff = /*#__PURE__*/ function(NodeAssertion) {
    "use strict";
    $51c7c8498af7e957$var$_inherits(EntityLinkAssertion, NodeAssertion);
    function EntityLinkAssertion(linkType, contentNodeTypes) {
        $51c7c8498af7e957$var$_class_call_check(this, EntityLinkAssertion);
        var _this;
        _this = $51c7c8498af7e957$var$_call_super(this, EntityLinkAssertion, [
            contentNodeTypes,
            function(data, path) {
                return $51c7c8498af7e957$var$_assert_this_initialized(_this).assertLink(data, path);
            }
        ]), $51c7c8498af7e957$var$_define_property(_this, "linkType", void 0), $51c7c8498af7e957$var$_define_property(_this, "type", void 0), $51c7c8498af7e957$var$_define_property(_this, "assertLink", void 0), _this.linkType = linkType, _this.assertLink = function(data, path) {
            var $ = new (0, $6VggO.ObjectAssertion)(data, path);
            if ($.object('target')) {
                var _$;
                var sys$ = new (0, $6VggO.ObjectAssertion)(data.target.sys, path.of('target').of('sys'));
                if (sys$.object()) {
                    sys$.enum('type', [
                        _this.type
                    ]);
                    sys$.enum('linkType', [
                        _this.linkType
                    ]);
                    if (_this.type === 'Link') {
                        sys$.string('id');
                        sys$.noAdditionalProperties([
                            'type',
                            'linkType',
                            'id'
                        ]);
                    } else if (_this.type === 'ResourceLink') {
                        sys$.string('urn');
                        sys$.noAdditionalProperties([
                            'type',
                            'linkType',
                            'urn'
                        ]);
                    }
                }
                (_$ = $).catch.apply(_$, $51c7c8498af7e957$var$_to_consumable_array(sys$.errors));
            }
            $.noAdditionalProperties([
                'target'
            ]);
            return $.errors;
        };
        _this.type = _this.linkType.startsWith('Contentful:') ? 'ResourceLink' : 'Link';
        return _this;
    }
    return EntityLinkAssertion;
}($51c7c8498af7e957$export$ec7e084baa688f3d);
var $51c7c8498af7e957$export$9115c851c20595ed = /*#__PURE__*/ function(NodeAssertion) {
    "use strict";
    $51c7c8498af7e957$var$_inherits(HyperLinkAssertion, NodeAssertion);
    function HyperLinkAssertion() {
        $51c7c8498af7e957$var$_class_call_check(this, HyperLinkAssertion);
        var _this;
        _this = $51c7c8498af7e957$var$_call_super(this, HyperLinkAssertion, [
            [
                'text'
            ],
            function(data, path) {
                return $51c7c8498af7e957$var$_assert_this_initialized(_this).assertLink(data, path);
            }
        ]), $51c7c8498af7e957$var$_define_property(_this, "assertLink", function(data, path) {
            var $ = new (0, $6VggO.ObjectAssertion)(data, path);
            $.string('uri');
            $.noAdditionalProperties([
                'uri'
            ]);
            return $.errors;
        });
        return _this;
    }
    return HyperLinkAssertion;
}($51c7c8498af7e957$export$ec7e084baa688f3d);
var $51c7c8498af7e957$export$a7a9523472993e97 = function(contentRule, validateData) {
    return new $51c7c8498af7e957$export$ec7e084baa688f3d(contentRule, validateData);
};
var $51c7c8498af7e957$export$b0de494632252d30 = function(linkType, contentRule) {
    return new $51c7c8498af7e957$export$f841b7ad0115c5ff(linkType, contentRule);
};

});

parcelRegister("81YbO", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $a43e8392634598ab$export$4b2950bdac9b6ee9; });
function $a43e8392634598ab$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a43e8392634598ab$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $a43e8392634598ab$var$_array_like_to_array(arr);
}
function $a43e8392634598ab$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a43e8392634598ab$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a43e8392634598ab$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a43e8392634598ab$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a43e8392634598ab$var$_to_consumable_array(arr) {
    return $a43e8392634598ab$var$_array_without_holes(arr) || $a43e8392634598ab$var$_iterable_to_array(arr) || $a43e8392634598ab$var$_unsupported_iterable_to_array(arr) || $a43e8392634598ab$var$_non_iterable_spread();
}
function $a43e8392634598ab$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a43e8392634598ab$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a43e8392634598ab$var$_array_like_to_array(o, minLen);
}
var $a43e8392634598ab$export$4b2950bdac9b6ee9 = function Path() {
    "use strict";
    var _this = this;
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    $a43e8392634598ab$var$_class_call_check(this, Path);
    $a43e8392634598ab$var$_define_property(this, "path", void 0);
    $a43e8392634598ab$var$_define_property(this, "of", void 0);
    $a43e8392634598ab$var$_define_property(this, "isRoot", void 0);
    $a43e8392634598ab$var$_define_property(this, "last", void 0);
    $a43e8392634598ab$var$_define_property(this, "toArray", void 0);
    this.path = path;
    this.of = function(element) {
        return new Path($a43e8392634598ab$var$_to_consumable_array(_this.path).concat([
            element
        ]));
    };
    this.isRoot = function() {
        return _this.path.length === 0;
    };
    this.last = function() {
        return _this.path[_this.path.length - 1];
    };
    this.toArray = function() {
        return _this.path;
    };
};

});

parcelRegister("hFFNv", function(module, exports) {

$parcel$export(module.exports, "assertText", function () { return $ce527f5076bbfe5e$export$920dd1849144744f; });

var $6VggO = parcelRequire("6VggO");
function $ce527f5076bbfe5e$export$920dd1849144744f(text, path) {
    var $ = new (0, $6VggO.ObjectAssertion)(text, path);
    if (!$.object()) return $.errors;
    $.noAdditionalProperties([
        'nodeType',
        'data',
        'value',
        'marks'
    ]);
    $.object('data');
    $.each('marks', function(mark, path) {
        var mark$ = new (0, $6VggO.ObjectAssertion)(mark, path);
        if (!mark$.object()) return mark$.errors;
        mark$.string('type');
        return mark$.errors;
    });
    $.string('value');
    return $.errors;
}

});



parcelRegister("bUBBP", function(module, exports) {
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */ 'use strict';
/**
 * Module variables.
 * @private
 */ var $8ac2190ebb87cb03$var$matchHtmlRegExp = /["'&<>]/;
/**
 * Module exports.
 * @public
 */ module.exports = $8ac2190ebb87cb03$var$escapeHtml;
/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */ function $8ac2190ebb87cb03$var$escapeHtml(string) {
    var str = '' + string;
    var match = $8ac2190ebb87cb03$var$matchHtmlRegExp.exec(str);
    if (!match) return str;
    var escape;
    var html = '';
    var index = 0;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escape = '&quot;';
                break;
            case 38:
                escape = '&amp;';
                break;
            case 39:
                escape = '&#39;';
                break;
            case 60:
                escape = '&lt;';
                break;
            case 62:
                escape = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.substring(lastIndex, index);
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

});


parcelRegister("ccVfB", function(module, exports) {

$parcel$export(module.exports, "fetchSections", function () { return $c349959130ac635b$export$7729b2a00926fbdd; });
$parcel$export(module.exports, "fetchMicrocopy", function () { return $c349959130ac635b$export$dc8341c6b813987a; });
// Minimal Contentful Delivery API client. Shared by the browser bundle and the
// build-time prerender, so it must stay free of DOM access and of the
// Contentful SDK (which drags Buffer/process polyfills into the bundle).
const $c349959130ac635b$var$usePreview = false;
const $c349959130ac635b$var$space = "78yxv8vx0foo";
const $c349959130ac635b$var$environment = 'master';
const $c349959130ac635b$var$accessToken = $c349959130ac635b$var$usePreview ? "iGcn84Q7dPqWZnk9CMVrqNv_UQKKctorZ4mgav2GoNI" : "v0n39BE4jn8dhAWRJbjgdKrRPXrTC3JoKjGeB8y80TU";
const $c349959130ac635b$var$baseUrl = `https://${$c349959130ac635b$var$usePreview ? 'preview' : 'cdn'}.contentful.com`;
const $c349959130ac635b$export$5cdae7cab003a07d = ()=>!!($c349959130ac635b$var$space && $c349959130ac635b$var$accessToken);
const $c349959130ac635b$var$isLink = (value)=>value && value.sys && value.sys.type === 'Link';
// The API returns linked entries/assets flat in `includes`; the SDK used to
// stitch them back into `fields`. This does the same, memoised per entry so
// cyclic references cannot recurse forever.
const $c349959130ac635b$var$resolveLinks = (response)=>{
    const lookup = new Map();
    const includes = response.includes || {};
    [
        ...includes.Entry || [],
        ...includes.Asset || [],
        ...response.items
    ].forEach((entry)=>lookup.set(entry.sys.id, entry));
    const resolved = new Map();
    const resolveEntry = (entry)=>{
        if (resolved.has(entry.sys.id)) return resolved.get(entry.sys.id);
        const copy = {
            sys: entry.sys,
            fields: {}
        };
        resolved.set(entry.sys.id, copy);
        Object.entries(entry.fields || {}).forEach(([key, value])=>{
            copy.fields[key] = resolveValue(value);
        });
        return copy;
    };
    const resolveNode = (node)=>{
        const next = {
            ...node
        };
        if (node.data && $c349959130ac635b$var$isLink(node.data.target)) {
            const target = lookup.get(node.data.target.sys.id);
            next.data = {
                ...node.data,
                target: target ? resolveEntry(target) : null
            };
        }
        if (Array.isArray(node.content)) next.content = node.content.map(resolveNode);
        return next;
    };
    const resolveValue = (value)=>{
        if (Array.isArray(value)) return value.map(resolveValue).filter(Boolean);
        if (!value || typeof value !== 'object') return value;
        if ($c349959130ac635b$var$isLink(value)) {
            const target = lookup.get(value.sys.id);
            return target ? resolveEntry(target) : null;
        }
        if (value.nodeType === 'document') return resolveNode(value);
        return value;
    };
    return {
        ...response,
        items: response.items.map(resolveEntry)
    };
};
const $c349959130ac635b$var$getEntries = (params)=>{
    const query = new URLSearchParams(params).toString();
    const url = `${$c349959130ac635b$var$baseUrl}/spaces/${$c349959130ac635b$var$space}/environments/${$c349959130ac635b$var$environment}/entries?${query}`;
    return fetch(url, {
        headers: {
            Authorization: `Bearer ${$c349959130ac635b$var$accessToken}`
        }
    }).then((res)=>{
        if (!res.ok) throw new Error(`Contentful responded ${res.status} for ${url}`);
        return res.json();
    }).then($c349959130ac635b$var$resolveLinks);
};
const $c349959130ac635b$var$parseSections = ({ items: items })=>items.map(({ fields: fields })=>{
        if (fields.items) return {
            ...fields,
            items: $c349959130ac635b$var$parseSections({
                items: fields.items
            })
        };
        return {
            ...fields,
            image: fields.image ? fields.image.fields : null
        };
    });
const $c349959130ac635b$var$parseMicrocopy = ({ items: items })=>items.reduce((acc, { fields: fields })=>({
            ...acc,
            [fields.key]: fields.value
        }), {});
const $c349959130ac635b$export$7729b2a00926fbdd = (locale)=>$c349959130ac635b$var$getEntries({
        content_type: 'sections',
        include: 10,
        locale: locale
    }).then($c349959130ac635b$var$parseSections);
const $c349959130ac635b$export$dc8341c6b813987a = (locale, { excludeLegalContent: excludeLegalContent = false } = {})=>{
    const params = {
        content_type: 'microcopy',
        locale: locale
    };
    if (excludeLegalContent) params['fields.key[nin]'] = 'legal.impressum.content,legal.datenschutz.content';
    return $c349959130ac635b$var$getEntries(params).then($c349959130ac635b$var$parseMicrocopy);
};

});

parcelRegister("gaesL", function(module, exports) {

$parcel$export(module.exports, "documentToPlainTextString", function () { return $bc48cc876ad68f50$export$16c55c8c145e9dad; }, function (v) { return $bc48cc876ad68f50$export$16c55c8c145e9dad = v; });
var $bc48cc876ad68f50$export$16c55c8c145e9dad;
'use strict';
parcelRequire("8a7Cy");
var $chn5L = parcelRequire("chn5L");
var $1VjU1 = parcelRequire("1VjU1");
function $bc48cc876ad68f50$var$documentToPlainTextString(rootNode, blockDivisor = ' ', options = {}) {
    if (!rootNode || !rootNode.content || !Array.isArray(rootNode.content)) return '';
    let processedRootNode = rootNode;
    if (rootNode.nodeType === $chn5L.BLOCKS.DOCUMENT && options.stripEmptyTrailingParagraph) processedRootNode = $1VjU1.stripEmptyTrailingParagraphFromDocument(rootNode);
    return processedRootNode.content.reduce((acc, node, i)=>{
        let nodeTextValue;
        if ($1VjU1.isText(node)) nodeTextValue = node.value;
        else if ($1VjU1.isBlock(node) || $1VjU1.isInline(node)) {
            nodeTextValue = $bc48cc876ad68f50$var$documentToPlainTextString(node, blockDivisor, options);
            if (!nodeTextValue.length) return acc;
        }
        const nextNode = processedRootNode.content[i + 1];
        const isNextNodeBlock = nextNode && $1VjU1.isBlock(nextNode);
        const divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}
$bc48cc876ad68f50$export$16c55c8c145e9dad = $bc48cc876ad68f50$var$documentToPlainTextString;

});


parcelRegister("aE8qp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c042cd25623c7e3$export$2e2bcd8739ae039; });

var $dPUqD = parcelRequire("dPUqD");

var $8ucNL = parcelRequire("8ucNL");
const $7c042cd25623c7e3$var$getTranslations = (lang)=>{
    const translations = {
        en: {
            consentModal: {
                title: 'Cookie settings',
                description: 'We use cookies to store your preferences and analyze site traffic. By clicking "Accept all", you consent to our use of analytics cookies.',
                acceptAllBtn: 'Accept all',
                acceptNecessaryBtn: 'Reject all',
                showPreferencesBtn: 'Manage preferences',
                footer: '<a href="/privacy">Privacy Policy</a> <span style="margin: 0 0.3rem;">|</span> <a href="/legal-notice">Legal Notice</a>'
            },
            preferencesModal: {
                title: 'Cookie preferences',
                acceptAllBtn: 'Accept all',
                acceptNecessaryBtn: 'Reject all',
                savePreferencesBtn: 'Save preferences',
                closeIconLabel: 'Close',
                sections: [
                    {
                        title: 'Cookie usage',
                        description: 'We use cookies to store your consent preferences and, only if you agree, to analyze website traffic. Nothing is sent to Google before you accept.'
                    },
                    {
                        title: 'Strictly necessary',
                        description: 'This cookie stores your consent preferences. It is essential for respecting your privacy choices and cannot be disabled.',
                        linkedCategory: 'necessary',
                        cookieTable: {
                            headers: {
                                name: 'Name',
                                domain: 'Domain',
                                expiration: 'Expiration',
                                description: 'Description'
                            },
                            body: [
                                {
                                    name: 'cc_cookie',
                                    domain: 'hinterland.software',
                                    expiration: '6 months',
                                    description: 'Stores your cookie consent preferences'
                                }
                            ]
                        }
                    },
                    {
                        title: 'Analytics',
                        description: 'These cookies are set by Google Analytics (via Google Tag Manager) to help us understand how visitors use the website. The data is collected anonymously.',
                        linkedCategory: 'analytics',
                        cookieTable: {
                            headers: {
                                name: 'Name',
                                domain: 'Domain',
                                expiration: 'Expiration',
                                description: 'Description'
                            },
                            body: [
                                {
                                    name: '_ga',
                                    domain: 'hinterland.software',
                                    expiration: '2 years',
                                    description: 'Google Analytics: Distinguishes unique users'
                                },
                                {
                                    name: '_ga_*',
                                    domain: 'hinterland.software',
                                    expiration: '2 years',
                                    description: 'Google Analytics: Maintains session state'
                                },
                                {
                                    name: '_gid',
                                    domain: 'hinterland.software',
                                    expiration: '24 hours',
                                    description: 'Google Analytics: Distinguishes users'
                                }
                            ]
                        }
                    }
                ]
            }
        },
        de: {
            consentModal: {
                title: 'Cookie-Einstellungen',
                description: 'Wir verwenden Cookies, um Ihre Einstellungen zu speichern und den Website-Traffic zu analysieren. Mit "Alle akzeptieren" stimmen Sie der Verwendung von Analyse-Cookies zu.',
                acceptAllBtn: 'Alle akzeptieren',
                acceptNecessaryBtn: 'Alle ablehnen',
                showPreferencesBtn: 'Einstellungen verwalten',
                footer: '<a href="/datenschutz">Datenschutz</a> <span style="margin: 0 0.3rem;">|</span> <a href="/impressum">Impressum</a>'
            },
            preferencesModal: {
                title: 'Cookie-Einstellungen',
                acceptAllBtn: 'Alle akzeptieren',
                acceptNecessaryBtn: 'Alle ablehnen',
                savePreferencesBtn: 'Einstellungen speichern',
                closeIconLabel: "Schlie\xdfen",
                sections: [
                    {
                        title: 'Cookie-Nutzung',
                        description: "Wir verwenden Cookies, um Ihre Einwilligungen zu speichern und, nur mit Ihrer Zustimmung, den Website-Traffic zu analysieren. Vor Ihrer Zustimmung werden keine Daten an Google \xfcbermittelt."
                    },
                    {
                        title: 'Notwendig',
                        description: "Dieses Cookie speichert Ihre Einwilligungseinstellungen. Es ist f\xfcr die Wahrung Ihrer Datenschutzentscheidungen unerl\xe4sslich und kann nicht deaktiviert werden.",
                        linkedCategory: 'necessary',
                        cookieTable: {
                            headers: {
                                name: 'Name',
                                domain: 'Domain',
                                expiration: "G\xfcltigkeit",
                                description: 'Beschreibung'
                            },
                            body: [
                                {
                                    name: 'cc_cookie',
                                    domain: 'hinterland.software',
                                    expiration: '6 Monate',
                                    description: 'Speichert Ihre Cookie-Einwilligungen'
                                }
                            ]
                        }
                    },
                    {
                        title: 'Analyse',
                        description: "Diese Cookies werden von Google Analytics (\xfcber Google Tag Manager) gesetzt, um zu verstehen, wie Besucher die Website nutzen. Die Daten werden anonym erhoben.",
                        linkedCategory: 'analytics',
                        cookieTable: {
                            headers: {
                                name: 'Name',
                                domain: 'Domain',
                                expiration: "G\xfcltigkeit",
                                description: 'Beschreibung'
                            },
                            body: [
                                {
                                    name: '_ga',
                                    domain: 'hinterland.software',
                                    expiration: '2 Jahre',
                                    description: 'Google Analytics: Unterscheidet eindeutige Nutzer'
                                },
                                {
                                    name: '_ga_*',
                                    domain: 'hinterland.software',
                                    expiration: '2 Jahre',
                                    description: "Google Analytics: Erh\xe4lt den Sitzungsstatus"
                                },
                                {
                                    name: '_gid',
                                    domain: 'hinterland.software',
                                    expiration: '24 Stunden',
                                    description: 'Google Analytics: Unterscheidet Nutzer'
                                }
                            ]
                        }
                    }
                ]
            }
        }
    };
    return translations[lang] || translations.en;
};
// gtag() must push the real `arguments` object, not a rest array, or GTM
// ignores the command.
function $7c042cd25623c7e3$var$gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
}
// Tags inside the container may call gtag() themselves, as the old inline
// script allowed.
window.gtag = $7c042cd25623c7e3$var$gtag;
let $7c042cd25623c7e3$var$gtmLoaded = false;
// Tag Manager is only fetched once analytics is accepted, so no request goes
// to Google for visitors who decline.
const $7c042cd25623c7e3$var$loadGtm = ()=>{
    if ($7c042cd25623c7e3$var$gtmLoaded) return;
    $7c042cd25623c7e3$var$gtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${0, $8ucNL.GTM_ID}`;
    document.head.appendChild(script);
};
const $7c042cd25623c7e3$var$updateConsent = (granted)=>{
    $7c042cd25623c7e3$var$gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied'
    });
    if (granted) $7c042cd25623c7e3$var$loadGtm();
    else if ($7c042cd25623c7e3$var$gtmLoaded) // A loaded container cannot be unloaded; the cookie library has already
    // cleared the _ga cookies, so a reload gives the visitor a page without it.
    window.location.reload();
};
const $7c042cd25623c7e3$export$35b3b49ddbf92ce5 = (lang = 'en')=>{
    $7c042cd25623c7e3$var$gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
    });
    // One consent for both language subdomains; local and preview hosts keep
    // the default host-only cookie.
    const onSiteHost = window.location.hostname === (0, $8ucNL.SITE_HOST) || window.location.hostname.endsWith(`.${(0, $8ucNL.SITE_HOST)}`);
    // Consent used to be stored host-only per subdomain. Browsers send the
    // older cookie first, and the library reads the first match, so a stale
    // acceptance would shadow a fresh rejection. Dropping the host-only copy
    // asks returning visitors once more, which is the safer of the two.
    if (onSiteHost) document.cookie = 'cc_cookie=; Max-Age=0; path=/; SameSite=Lax; Secure';
    $dPUqD.run({
        cookie: onSiteHost ? {
            domain: (0, $8ucNL.SITE_HOST)
        } : {},
        guiOptions: {
            consentModal: {
                layout: 'box wide',
                position: 'bottom center'
            },
            preferencesModal: {
                layout: 'box'
            }
        },
        categories: {
            necessary: {
                enabled: true,
                readOnly: true
            },
            analytics: {
                autoClear: {
                    // GA writes its cookies on the registrable domain, not on the
                    // language subdomain the page runs on, so both scopes are cleared.
                    cookies: [
                        {
                            name: /^_ga/
                        },
                        {
                            name: '_gid'
                        },
                        {
                            name: /^_ga/,
                            domain: (0, $8ucNL.SITE_HOST)
                        },
                        {
                            name: '_gid',
                            domain: (0, $8ucNL.SITE_HOST)
                        }
                    ]
                }
            }
        },
        language: {
            default: lang,
            translations: {
                en: $7c042cd25623c7e3$var$getTranslations('en'),
                de: $7c042cd25623c7e3$var$getTranslations('de')
            }
        },
        onConsent: ()=>{
            $7c042cd25623c7e3$var$updateConsent($dPUqD.acceptedCategory('analytics'));
        },
        onChange: ()=>{
            $7c042cd25623c7e3$var$updateConsent($dPUqD.acceptedCategory('analytics'));
        }
    });
};
var $7c042cd25623c7e3$export$2e2bcd8739ae039 = $7c042cd25623c7e3$export$35b3b49ddbf92ce5;

});
parcelRegister("dPUqD", function(module, exports) {

$parcel$export(module.exports, "acceptedCategory", function () { return $a12bcf4f10be538e$export$d57953daf19d40f0; });
$parcel$export(module.exports, "run", function () { return $a12bcf4f10be538e$export$889ea624f2cb2c57; });
/*!
* CookieConsent 3.1.0
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/ const $a12bcf4f10be538e$var$e = 'opt-in', $a12bcf4f10be538e$var$t = 'opt-out', $a12bcf4f10be538e$var$o = 'show--consent', $a12bcf4f10be538e$var$n = 'show--preferences', $a12bcf4f10be538e$var$a = 'disable--interaction', $a12bcf4f10be538e$var$s = 'data-category', $a12bcf4f10be538e$var$c = 'div', $a12bcf4f10be538e$var$r = 'button', $a12bcf4f10be538e$var$i = 'aria-hidden', $a12bcf4f10be538e$var$l = 'btn-group', $a12bcf4f10be538e$var$d = 'click', $a12bcf4f10be538e$var$f = 'data-role', $a12bcf4f10be538e$var$_ = 'consentModal', $a12bcf4f10be538e$var$u = 'preferencesModal';
class $a12bcf4f10be538e$var$p {
    constructor(){
        this.t = {
            mode: $a12bcf4f10be538e$var$e,
            revision: 0,
            autoShow: !0,
            lazyHtmlGeneration: !0,
            autoClearCookies: !0,
            manageScriptTags: !0,
            hideFromBots: !0,
            cookie: {
                name: 'cc_cookie',
                expiresAfterDays: 182,
                domain: '',
                path: '/',
                secure: !0,
                sameSite: 'Lax'
            }
        }, this.o = {
            i: {},
            l: '',
            _: {},
            u: {},
            p: {},
            m: [],
            v: !1,
            h: null,
            C: null,
            S: null,
            M: '',
            D: !0,
            T: !1,
            k: !1,
            A: !1,
            N: !1,
            H: [],
            V: !1,
            I: !0,
            L: [],
            j: !1,
            F: '',
            P: !1,
            O: [],
            R: [],
            B: [],
            $: [],
            G: !1,
            J: !1,
            U: !1,
            q: [],
            K: [],
            W: [],
            X: {},
            Y: {},
            Z: {},
            ee: {},
            te: {},
            oe: []
        }, this.ne = {
            ae: {},
            se: {}
        }, this.ce = {}, this.re = {
            ie: 'cc:onFirstConsent',
            le: 'cc:onConsent',
            de: 'cc:onChange',
            fe: 'cc:onModalShow',
            _e: 'cc:onModalHide',
            ue: 'cc:onModalReady'
        };
    }
}
const $a12bcf4f10be538e$var$g = new $a12bcf4f10be538e$var$p, $a12bcf4f10be538e$var$m = (e, t)=>e.indexOf(t), $a12bcf4f10be538e$var$b = (e, t)=>-1 !== $a12bcf4f10be538e$var$m(e, t), $a12bcf4f10be538e$var$v = (e)=>Array.isArray(e), $a12bcf4f10be538e$var$y = (e)=>'string' == typeof e, $a12bcf4f10be538e$var$h = (e)=>!!e && 'object' == typeof e && !$a12bcf4f10be538e$var$v(e), $a12bcf4f10be538e$var$C = (e)=>'function' == typeof e, $a12bcf4f10be538e$var$w = (e)=>Object.keys(e), $a12bcf4f10be538e$var$S = (e)=>Array.from(new Set(e)), $a12bcf4f10be538e$var$x = ()=>document.activeElement, $a12bcf4f10be538e$var$M = (e)=>e.preventDefault(), $a12bcf4f10be538e$var$D = (e, t)=>e.querySelectorAll(t), $a12bcf4f10be538e$var$T = (e)=>e.dispatchEvent(new Event('change')), $a12bcf4f10be538e$var$k = (e)=>{
    const t = document.createElement(e);
    return e === $a12bcf4f10be538e$var$r && (t.type = e), t;
}, $a12bcf4f10be538e$var$E = (e, t, o)=>e.setAttribute(t, o), $a12bcf4f10be538e$var$A = (e, t, o)=>{
    e.removeAttribute(o ? 'data-' + t : t);
}, $a12bcf4f10be538e$var$N = (e, t, o)=>e.getAttribute(o ? 'data-' + t : t), $a12bcf4f10be538e$var$H = (e, t)=>e.appendChild(t), $a12bcf4f10be538e$var$V = (e, t)=>e.classList.add(t), $a12bcf4f10be538e$var$I = (e, t)=>$a12bcf4f10be538e$var$V(e, 'cm__' + t), $a12bcf4f10be538e$var$L = (e, t)=>$a12bcf4f10be538e$var$V(e, 'pm__' + t), $a12bcf4f10be538e$var$j = (e, t)=>e.classList.remove(t), $a12bcf4f10be538e$var$F = (e)=>{
    if ('object' != typeof e) return e;
    if (e instanceof Date) return new Date(e.getTime());
    let t = Array.isArray(e) ? [] : {};
    for(let o in e){
        let n = e[o];
        t[o] = $a12bcf4f10be538e$var$F(n);
    }
    return t;
}, $a12bcf4f10be538e$var$P = ()=>{
    const e = {}, { O: t, X: o, Y: n } = $a12bcf4f10be538e$var$g.o;
    for (const a of t)e[a] = $a12bcf4f10be538e$var$$(n[a], $a12bcf4f10be538e$var$w(o[a]));
    return e;
}, $a12bcf4f10be538e$var$O = (e, t)=>dispatchEvent(new CustomEvent(e, {
        detail: t
    })), $a12bcf4f10be538e$var$R = (e, t, o, n)=>{
    e.addEventListener(t, o), n && $a12bcf4f10be538e$var$g.o.m.push({
        pe: e,
        ge: t,
        me: o
    });
}, $a12bcf4f10be538e$var$B = ()=>{
    const e = $a12bcf4f10be538e$var$g.t.cookie.expiresAfterDays;
    return $a12bcf4f10be538e$var$C(e) ? e($a12bcf4f10be538e$var$g.o.F) : e;
}, $a12bcf4f10be538e$var$$ = (e, t)=>{
    const o = e || [], n = t || [];
    return o.filter((e)=>!$a12bcf4f10be538e$var$b(n, e)).concat(n.filter((e)=>!$a12bcf4f10be538e$var$b(o, e)));
}, $a12bcf4f10be538e$var$G = (e)=>{
    $a12bcf4f10be538e$var$g.o.R = $a12bcf4f10be538e$var$S(e), $a12bcf4f10be538e$var$g.o.F = (()=>{
        let e = 'custom';
        const { R: t, O: o, B: n } = $a12bcf4f10be538e$var$g.o, a = t.length;
        return a === o.length ? e = 'all' : a === n.length && (e = 'necessary'), e;
    })();
}, $a12bcf4f10be538e$var$J = (e, t, o, n)=>{
    const a = 'accept-', { show: s, showPreferences: c, hide: r, hidePreferences: i, acceptCategory: l } = t, f = e || document, _ = (e)=>$a12bcf4f10be538e$var$D(f, `[data-cc="${e}"]`), u = (e, t)=>{
        $a12bcf4f10be538e$var$M(e), l(t), i(), r();
    }, p = _('show-preferencesModal'), m = _('show-consentModal'), b = _(a + 'all'), v = _(a + 'necessary'), y = _(a + 'custom'), h = $a12bcf4f10be538e$var$g.t.lazyHtmlGeneration;
    for (const e of p)$a12bcf4f10be538e$var$E(e, 'aria-haspopup', 'dialog'), $a12bcf4f10be538e$var$R(e, $a12bcf4f10be538e$var$d, (e)=>{
        $a12bcf4f10be538e$var$M(e), c();
    }), h && ($a12bcf4f10be538e$var$R(e, 'mouseenter', (e)=>{
        $a12bcf4f10be538e$var$M(e), $a12bcf4f10be538e$var$g.o.N || o(t, n);
    }, !0), $a12bcf4f10be538e$var$R(e, 'focus', ()=>{
        $a12bcf4f10be538e$var$g.o.N || o(t, n);
    }));
    for (let e of m)$a12bcf4f10be538e$var$E(e, 'aria-haspopup', 'dialog'), $a12bcf4f10be538e$var$R(e, $a12bcf4f10be538e$var$d, (e)=>{
        $a12bcf4f10be538e$var$M(e), s(!0);
    }, !0);
    for (let e of b)$a12bcf4f10be538e$var$R(e, $a12bcf4f10be538e$var$d, (e)=>{
        u(e, 'all');
    }, !0);
    for (let e of y)$a12bcf4f10be538e$var$R(e, $a12bcf4f10be538e$var$d, (e)=>{
        u(e);
    }, !0);
    for (let e of v)$a12bcf4f10be538e$var$R(e, $a12bcf4f10be538e$var$d, (e)=>{
        u(e, []);
    }, !0);
}, $a12bcf4f10be538e$var$U = (e, t)=>{
    e && (t && (e.tabIndex = -1), e.focus(), t && e.removeAttribute('tabindex'));
}, $a12bcf4f10be538e$var$z = (e, t)=>{
    const o = (n)=>{
        n.target.removeEventListener('transitionend', o), 'opacity' === n.propertyName && '1' === getComputedStyle(e).opacity && $a12bcf4f10be538e$var$U(((e)=>1 === e ? $a12bcf4f10be538e$var$g.ne.be : $a12bcf4f10be538e$var$g.ne.ve)(t));
    };
    $a12bcf4f10be538e$var$R(e, 'transitionend', o);
};
let $a12bcf4f10be538e$var$q;
const $a12bcf4f10be538e$var$K = (e)=>{
    clearTimeout($a12bcf4f10be538e$var$q), e ? $a12bcf4f10be538e$var$V($a12bcf4f10be538e$var$g.ne.ye, $a12bcf4f10be538e$var$a) : $a12bcf4f10be538e$var$q = setTimeout(()=>{
        $a12bcf4f10be538e$var$j($a12bcf4f10be538e$var$g.ne.ye, $a12bcf4f10be538e$var$a);
    }, 500);
}, $a12bcf4f10be538e$var$Q = [
    'M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5',
    'M 3.572 13.406 L 8.281 18.115 L 20.428 5.885',
    'M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 '
], $a12bcf4f10be538e$var$W = (e = 0, t = 1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${$a12bcf4f10be538e$var$Q[e]}"/></svg>`, $a12bcf4f10be538e$var$X = (e)=>{
    const t = $a12bcf4f10be538e$var$g.ne, o = $a12bcf4f10be538e$var$g.o;
    ((e)=>{
        const n = e === t.he, a = o.i.disablePageInteraction ? t.ye : n ? t.Ce : t.ye;
        $a12bcf4f10be538e$var$R(a, 'keydown', (t)=>{
            if ('Tab' !== t.key || !(n ? o.k && !o.A : o.A)) return;
            const a = $a12bcf4f10be538e$var$x(), s = n ? o.q : o.K;
            0 !== s.length && (t.shiftKey ? a !== s[0] && e.contains(a) || ($a12bcf4f10be538e$var$M(t), $a12bcf4f10be538e$var$U(s[1])) : a !== s[1] && e.contains(a) || ($a12bcf4f10be538e$var$M(t), $a12bcf4f10be538e$var$U(s[0])));
        }, !0);
    })(e);
}, $a12bcf4f10be538e$var$Y = [
    '[href]',
    $a12bcf4f10be538e$var$r,
    'input',
    'details',
    '[tabindex]'
].map((e)=>e + ':not([tabindex="-1"])').join(','), $a12bcf4f10be538e$var$Z = (e)=>{
    const { o: t, ne: o } = $a12bcf4f10be538e$var$g, n = (e, t)=>{
        const o = $a12bcf4f10be538e$var$D(e, $a12bcf4f10be538e$var$Y);
        t[0] = o[0], t[1] = o[o.length - 1];
    };
    1 === e && t.T && n(o.he, t.q), 2 === e && t.N && n(o.we, t.K);
}, $a12bcf4f10be538e$var$ee = (e, t, o)=>{
    const { de: n, le: a, ie: s, _e: c, ue: r, fe: i } = $a12bcf4f10be538e$var$g.ce, l = $a12bcf4f10be538e$var$g.re;
    if (t) {
        const n = {
            modalName: t
        };
        return e === l.fe ? $a12bcf4f10be538e$var$C(i) && i(n) : e === l._e ? $a12bcf4f10be538e$var$C(c) && c(n) : (n.modal = o, $a12bcf4f10be538e$var$C(r) && r(n)), $a12bcf4f10be538e$var$O(e, n);
    }
    const d = {
        cookie: $a12bcf4f10be538e$var$g.o.p
    };
    e === l.ie ? $a12bcf4f10be538e$var$C(s) && s($a12bcf4f10be538e$var$F(d)) : e === l.le ? $a12bcf4f10be538e$var$C(a) && a($a12bcf4f10be538e$var$F(d)) : (d.changedCategories = $a12bcf4f10be538e$var$g.o.L, d.changedServices = $a12bcf4f10be538e$var$g.o.ee, $a12bcf4f10be538e$var$C(n) && n($a12bcf4f10be538e$var$F(d))), $a12bcf4f10be538e$var$O(e, $a12bcf4f10be538e$var$F(d));
}, $a12bcf4f10be538e$var$te = (e, t)=>{
    try {
        return e();
    } catch (e) {
        return !t && console.warn('CookieConsent:', e), !1;
    }
}, $a12bcf4f10be538e$var$oe = (e)=>{
    const { Y: t, ee: o, O: n, X: a, oe: c, p: r, L: i } = $a12bcf4f10be538e$var$g.o;
    for (const e of n){
        const n = o[e] || t[e] || [];
        for (const o of n){
            const n = a[e][o];
            if (!n) continue;
            const { onAccept: s, onReject: c } = n;
            !n.Se && $a12bcf4f10be538e$var$b(t[e], o) ? (n.Se = !0, $a12bcf4f10be538e$var$C(s) && s()) : n.Se && !$a12bcf4f10be538e$var$b(t[e], o) && (n.Se = !1, $a12bcf4f10be538e$var$C(c) && c());
        }
    }
    if (!$a12bcf4f10be538e$var$g.t.manageScriptTags) return;
    const l = c, d = e || r.categories || [], f = (e, n)=>{
        if (n >= e.length) return;
        const a = c[n];
        if (a.xe) return f(e, n + 1);
        const r = a.Me, l = a.De, _ = a.Te, u = $a12bcf4f10be538e$var$b(d, l), p = !!_ && $a12bcf4f10be538e$var$b(t[l], _);
        if (!_ && !a.ke && u || !_ && a.ke && !u && $a12bcf4f10be538e$var$b(i, l) || _ && !a.ke && p || _ && a.ke && !p && $a12bcf4f10be538e$var$b(o[l] || [], _)) {
            a.xe = !0;
            const t = $a12bcf4f10be538e$var$N(r, 'type', !0);
            $a12bcf4f10be538e$var$A(r, 'type', !!t), $a12bcf4f10be538e$var$A(r, $a12bcf4f10be538e$var$s);
            let o = $a12bcf4f10be538e$var$N(r, 'src', !0);
            o && $a12bcf4f10be538e$var$A(r, 'src', !0);
            const c = $a12bcf4f10be538e$var$k('script');
            c.textContent = r.innerHTML;
            for (const { nodeName: e } of r.attributes)$a12bcf4f10be538e$var$E(c, e, r[e] || $a12bcf4f10be538e$var$N(r, e));
            t && (c.type = t), o ? c.src = o : o = r.src;
            const i = !!o && (!t || [
                'text/javascript',
                'module'
            ].includes(t));
            if (i && (c.onload = c.onerror = ()=>{
                f(e, ++n);
            }), r.replaceWith(c), i) return;
        }
        f(e, ++n);
    };
    f(l, 0);
}, $a12bcf4f10be538e$var$ne = 'bottom', $a12bcf4f10be538e$var$ae = 'left', $a12bcf4f10be538e$var$se = 'center', $a12bcf4f10be538e$var$ce = 'right', $a12bcf4f10be538e$var$re = 'inline', $a12bcf4f10be538e$var$ie = 'wide', $a12bcf4f10be538e$var$le = 'pm--', $a12bcf4f10be538e$var$de = [
    'middle',
    'top',
    $a12bcf4f10be538e$var$ne
], $a12bcf4f10be538e$var$fe = [
    $a12bcf4f10be538e$var$ae,
    $a12bcf4f10be538e$var$se,
    $a12bcf4f10be538e$var$ce
], $a12bcf4f10be538e$var$_e = {
    box: {
        Ee: [
            $a12bcf4f10be538e$var$ie,
            $a12bcf4f10be538e$var$re
        ],
        Ae: $a12bcf4f10be538e$var$de,
        Ne: $a12bcf4f10be538e$var$fe,
        He: $a12bcf4f10be538e$var$ne,
        Ve: $a12bcf4f10be538e$var$ce
    },
    cloud: {
        Ee: [
            $a12bcf4f10be538e$var$re
        ],
        Ae: $a12bcf4f10be538e$var$de,
        Ne: $a12bcf4f10be538e$var$fe,
        He: $a12bcf4f10be538e$var$ne,
        Ve: $a12bcf4f10be538e$var$se
    },
    bar: {
        Ee: [
            $a12bcf4f10be538e$var$re
        ],
        Ae: $a12bcf4f10be538e$var$de.slice(1),
        Ne: [],
        He: $a12bcf4f10be538e$var$ne,
        Ve: ''
    }
}, $a12bcf4f10be538e$var$ue = {
    box: {
        Ee: [],
        Ae: [],
        Ne: [],
        He: '',
        Ve: ''
    },
    bar: {
        Ee: [
            $a12bcf4f10be538e$var$ie
        ],
        Ae: [],
        Ne: [
            $a12bcf4f10be538e$var$ae,
            $a12bcf4f10be538e$var$ce
        ],
        He: '',
        Ve: $a12bcf4f10be538e$var$ae
    }
}, $a12bcf4f10be538e$var$pe = (e)=>{
    const t = $a12bcf4f10be538e$var$g.o.i.guiOptions, o = t && t.consentModal, n = t && t.preferencesModal;
    0 === e && $a12bcf4f10be538e$var$ge($a12bcf4f10be538e$var$g.ne.he, $a12bcf4f10be538e$var$_e, o, 'cm--', 'box', 'cm'), 1 === e && $a12bcf4f10be538e$var$ge($a12bcf4f10be538e$var$g.ne.we, $a12bcf4f10be538e$var$ue, n, $a12bcf4f10be538e$var$le, 'box', 'pm');
}, $a12bcf4f10be538e$var$ge = (e, t, o, n, a, s)=>{
    e.className = s;
    const c = o && o.layout, r = o && o.position, i = o && o.flipButtons, l = !o || !1 !== o.equalWeightButtons, d = c && c.split(' ') || [], f = d[0], _ = d[1], u = f in t ? f : a, p = t[u], m = $a12bcf4f10be538e$var$b(p.Ee, _) && _, v = r && r.split(' ') || [], y = v[0], h = n === $a12bcf4f10be538e$var$le ? v[0] : v[1], C = $a12bcf4f10be538e$var$b(p.Ae, y) ? y : p.He, w = $a12bcf4f10be538e$var$b(p.Ne, h) ? h : p.Ve, S = (t)=>{
        t && $a12bcf4f10be538e$var$V(e, n + t);
    };
    S(u), S(m), S(C), S(w), i && S('flip');
    const x = s + '__btn--secondary';
    if ('cm' === s) {
        const { Ie: e, Le: t } = $a12bcf4f10be538e$var$g.ne;
        e && (l ? $a12bcf4f10be538e$var$j(e, x) : $a12bcf4f10be538e$var$V(e, x)), t && (l ? $a12bcf4f10be538e$var$j(t, x) : $a12bcf4f10be538e$var$V(t, x));
    } else {
        const { je: e } = $a12bcf4f10be538e$var$g.ne;
        e && (l ? $a12bcf4f10be538e$var$j(e, x) : $a12bcf4f10be538e$var$V(e, x));
    }
}, $a12bcf4f10be538e$var$me = (e, t)=>{
    const o = $a12bcf4f10be538e$var$g.o, n = $a12bcf4f10be538e$var$g.ne, { hide: a, hidePreferences: s, acceptCategory: _ } = e, p = (e)=>{
        _(e), s(), a();
    }, m = o.u && o.u.preferencesModal;
    if (!m) return;
    const b = m.title, v = m.closeIconLabel, C = m.acceptAllBtn, S = m.acceptNecessaryBtn, x = m.savePreferencesBtn, M = m.sections || [], D = C || S || x;
    if (n.Fe) n.Pe = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$L(n.Pe, 'body');
    else {
        n.Fe = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$V(n.Fe, 'pm-wrapper');
        const e = $a12bcf4f10be538e$var$k('div');
        $a12bcf4f10be538e$var$V(e, 'pm-overlay'), $a12bcf4f10be538e$var$H(n.Fe, e), $a12bcf4f10be538e$var$R(e, $a12bcf4f10be538e$var$d, s), n.we = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$V(n.we, 'pm'), $a12bcf4f10be538e$var$E(n.we, 'role', 'dialog'), $a12bcf4f10be538e$var$E(n.we, $a12bcf4f10be538e$var$i, !0), $a12bcf4f10be538e$var$E(n.we, 'aria-modal', !0), $a12bcf4f10be538e$var$E(n.we, 'aria-labelledby', 'pm__title'), $a12bcf4f10be538e$var$R(n.ye, 'keydown', (e)=>{
            27 === e.keyCode && s();
        }, !0), n.Oe = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$L(n.Oe, 'header'), n.Re = $a12bcf4f10be538e$var$k('h2'), $a12bcf4f10be538e$var$L(n.Re, 'title'), n.Re.id = 'pm__title', n.Be = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$L(n.Be, 'close-btn'), $a12bcf4f10be538e$var$E(n.Be, 'aria-label', m.closeIconLabel || ''), $a12bcf4f10be538e$var$R(n.Be, $a12bcf4f10be538e$var$d, s), n.$e = $a12bcf4f10be538e$var$k('span'), n.$e.innerHTML = $a12bcf4f10be538e$var$W(), $a12bcf4f10be538e$var$H(n.Be, n.$e), n.Ge = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$L(n.Ge, 'body'), n.Je = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$L(n.Je, 'footer');
        var T = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
        $a12bcf4f10be538e$var$V(T, 'btns');
        var A = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), N = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
        $a12bcf4f10be538e$var$L(A, $a12bcf4f10be538e$var$l), $a12bcf4f10be538e$var$L(N, $a12bcf4f10be538e$var$l), $a12bcf4f10be538e$var$H(n.Je, A), $a12bcf4f10be538e$var$H(n.Je, N), $a12bcf4f10be538e$var$H(n.Oe, n.Re), $a12bcf4f10be538e$var$H(n.Oe, n.Be), n.ve = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$E(n.ve, 'tabIndex', -1), $a12bcf4f10be538e$var$H(n.we, n.ve), $a12bcf4f10be538e$var$H(n.we, n.Oe), $a12bcf4f10be538e$var$H(n.we, n.Ge), D && $a12bcf4f10be538e$var$H(n.we, n.Je), $a12bcf4f10be538e$var$H(n.Fe, n.we);
    }
    let I;
    b && (n.Re.innerHTML = b, v && $a12bcf4f10be538e$var$E(n.Be, 'aria-label', v)), M.forEach((e, t)=>{
        const a = e.title, s = e.description, l = e.linkedCategory, f = l && o.P[l], _ = e.cookieTable, u = _ && _.body, p = _ && _.caption, g = u && u.length > 0, b = !!f, v = b && o.X[l], C = $a12bcf4f10be538e$var$h(v) && $a12bcf4f10be538e$var$w(v) || [], S = b && (!!s || !!g || $a12bcf4f10be538e$var$w(v).length > 0);
        var x = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
        if ($a12bcf4f10be538e$var$L(x, 'section'), S || s) {
            var M = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
            $a12bcf4f10be538e$var$L(M, 'section-desc-wrapper');
        }
        let D = C.length;
        if (S && D > 0) {
            const e = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
            $a12bcf4f10be538e$var$L(e, 'section-services');
            for (const t of C){
                const o = v[t], n = o && o.label || t, a = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), s = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), r = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), i = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
                $a12bcf4f10be538e$var$L(a, 'service'), $a12bcf4f10be538e$var$L(i, 'service-title'), $a12bcf4f10be538e$var$L(s, 'service-header'), $a12bcf4f10be538e$var$L(r, 'service-icon');
                const d = $a12bcf4f10be538e$var$be(n, t, f, !0, l);
                i.innerHTML = n, $a12bcf4f10be538e$var$H(s, r), $a12bcf4f10be538e$var$H(s, i), $a12bcf4f10be538e$var$H(a, s), $a12bcf4f10be538e$var$H(a, d), $a12bcf4f10be538e$var$H(e, a);
            }
            $a12bcf4f10be538e$var$H(M, e);
        }
        if (a) {
            var T = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), A = $a12bcf4f10be538e$var$k(b ? $a12bcf4f10be538e$var$r : $a12bcf4f10be538e$var$c);
            if ($a12bcf4f10be538e$var$L(T, 'section-title-wrapper'), $a12bcf4f10be538e$var$L(A, 'section-title'), A.innerHTML = a, $a12bcf4f10be538e$var$H(T, A), b) {
                const e = $a12bcf4f10be538e$var$k('span');
                e.innerHTML = $a12bcf4f10be538e$var$W(2, 3.5), $a12bcf4f10be538e$var$L(e, 'section-arrow'), $a12bcf4f10be538e$var$H(T, e), x.className += '--toggle';
                const t = $a12bcf4f10be538e$var$be(a, l, f);
                let o = m.serviceCounterLabel;
                if (D > 0 && $a12bcf4f10be538e$var$y(o)) {
                    let e = $a12bcf4f10be538e$var$k('span');
                    $a12bcf4f10be538e$var$L(e, 'badge'), $a12bcf4f10be538e$var$L(e, 'service-counter'), $a12bcf4f10be538e$var$E(e, $a12bcf4f10be538e$var$i, !0), $a12bcf4f10be538e$var$E(e, 'data-servicecounter', D), o && (o = o.split('|'), o = o.length > 1 && D > 1 ? o[1] : o[0], $a12bcf4f10be538e$var$E(e, 'data-counterlabel', o)), e.innerHTML = D + (o ? ' ' + o : ''), $a12bcf4f10be538e$var$H(A, e);
                }
                if (S) {
                    $a12bcf4f10be538e$var$L(x, 'section--expandable');
                    var N = l + '-desc';
                    $a12bcf4f10be538e$var$E(A, 'aria-expanded', !1), $a12bcf4f10be538e$var$E(A, 'aria-controls', N);
                }
                $a12bcf4f10be538e$var$H(T, t);
            } else $a12bcf4f10be538e$var$E(A, 'role', 'heading'), $a12bcf4f10be538e$var$E(A, 'aria-level', '3');
            $a12bcf4f10be538e$var$H(x, T);
        }
        if (s) {
            var F = $a12bcf4f10be538e$var$k('p');
            $a12bcf4f10be538e$var$L(F, 'section-desc'), F.innerHTML = s, $a12bcf4f10be538e$var$H(M, F);
        }
        if (S && ($a12bcf4f10be538e$var$E(M, $a12bcf4f10be538e$var$i, 'true'), M.id = N, ((e, t, o)=>{
            $a12bcf4f10be538e$var$R(A, $a12bcf4f10be538e$var$d, ()=>{
                t.classList.contains('is-expanded') ? ($a12bcf4f10be538e$var$j(t, 'is-expanded'), $a12bcf4f10be538e$var$E(o, 'aria-expanded', 'false'), $a12bcf4f10be538e$var$E(e, $a12bcf4f10be538e$var$i, 'true')) : ($a12bcf4f10be538e$var$V(t, 'is-expanded'), $a12bcf4f10be538e$var$E(o, 'aria-expanded', 'true'), $a12bcf4f10be538e$var$E(e, $a12bcf4f10be538e$var$i, 'false'));
            });
        })(M, x, A), g)) {
            const e = $a12bcf4f10be538e$var$k('table'), o = $a12bcf4f10be538e$var$k('thead'), a = $a12bcf4f10be538e$var$k('tbody');
            if (p) {
                const t = $a12bcf4f10be538e$var$k('caption');
                $a12bcf4f10be538e$var$L(t, 'table-caption'), t.innerHTML = p, e.appendChild(t);
            }
            $a12bcf4f10be538e$var$L(e, 'section-table'), $a12bcf4f10be538e$var$L(o, 'table-head'), $a12bcf4f10be538e$var$L(a, 'table-body');
            const s = _.headers, r = $a12bcf4f10be538e$var$w(s), i = n.Ue.createDocumentFragment(), l = $a12bcf4f10be538e$var$k('tr');
            for (const e of r){
                const o = s[e], n = $a12bcf4f10be538e$var$k('th');
                n.id = 'cc__row-' + o + t, $a12bcf4f10be538e$var$E(n, 'scope', 'col'), $a12bcf4f10be538e$var$L(n, 'table-th'), n.innerHTML = o, $a12bcf4f10be538e$var$H(i, n);
            }
            $a12bcf4f10be538e$var$H(l, i), $a12bcf4f10be538e$var$H(o, l);
            const d = n.Ue.createDocumentFragment();
            for (const e of u){
                const o = $a12bcf4f10be538e$var$k('tr');
                $a12bcf4f10be538e$var$L(o, 'table-tr');
                for (const n of r){
                    const a = s[n], r = e[n], i = $a12bcf4f10be538e$var$k('td'), l = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
                    $a12bcf4f10be538e$var$L(i, 'table-td'), $a12bcf4f10be538e$var$E(i, 'data-column', a), $a12bcf4f10be538e$var$E(i, 'headers', 'cc__row-' + a + t), l.insertAdjacentHTML('beforeend', r), $a12bcf4f10be538e$var$H(i, l), $a12bcf4f10be538e$var$H(o, i);
                }
                $a12bcf4f10be538e$var$H(d, o);
            }
            $a12bcf4f10be538e$var$H(a, d), $a12bcf4f10be538e$var$H(e, o), $a12bcf4f10be538e$var$H(e, a), $a12bcf4f10be538e$var$H(M, e);
        }
        (S || s) && $a12bcf4f10be538e$var$H(x, M);
        const P = n.Pe || n.Ge;
        b ? (I || (I = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$L(I, 'section-toggles')), I.appendChild(x)) : I = null, $a12bcf4f10be538e$var$H(P, I || x);
    }), C && (n.ze || (n.ze = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$L(n.ze, 'btn'), $a12bcf4f10be538e$var$E(n.ze, $a12bcf4f10be538e$var$f, 'all'), $a12bcf4f10be538e$var$H(A, n.ze), $a12bcf4f10be538e$var$R(n.ze, $a12bcf4f10be538e$var$d, ()=>p('all'))), n.ze.innerHTML = C), S && (n.je || (n.je = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$L(n.je, 'btn'), $a12bcf4f10be538e$var$E(n.je, $a12bcf4f10be538e$var$f, 'necessary'), $a12bcf4f10be538e$var$H(A, n.je), $a12bcf4f10be538e$var$R(n.je, $a12bcf4f10be538e$var$d, ()=>p([]))), n.je.innerHTML = S), x && (n.qe || (n.qe = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$L(n.qe, 'btn'), $a12bcf4f10be538e$var$L(n.qe, 'btn--secondary'), $a12bcf4f10be538e$var$E(n.qe, $a12bcf4f10be538e$var$f, 'save'), $a12bcf4f10be538e$var$H(N, n.qe), $a12bcf4f10be538e$var$R(n.qe, $a12bcf4f10be538e$var$d, ()=>p())), n.qe.innerHTML = x), n.Pe && (n.we.replaceChild(n.Pe, n.Ge), n.Ge = n.Pe), $a12bcf4f10be538e$var$pe(1), o.N || (o.N = !0, $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.ue, $a12bcf4f10be538e$var$u, n.we), t(e), $a12bcf4f10be538e$var$H(n.Ce, n.Fe), $a12bcf4f10be538e$var$X(n.we), setTimeout(()=>$a12bcf4f10be538e$var$V(n.Fe, 'cc--anim'), 100)), $a12bcf4f10be538e$var$Z(2);
};
function $a12bcf4f10be538e$var$be(e, t, o, n, a) {
    const c = $a12bcf4f10be538e$var$g.o, r = $a12bcf4f10be538e$var$g.ne, l = $a12bcf4f10be538e$var$k('label'), f = $a12bcf4f10be538e$var$k('input'), _ = $a12bcf4f10be538e$var$k('span'), u = $a12bcf4f10be538e$var$k('span'), p = $a12bcf4f10be538e$var$k('span'), m = $a12bcf4f10be538e$var$k('span'), v = $a12bcf4f10be538e$var$k('span');
    if (m.innerHTML = $a12bcf4f10be538e$var$W(1, 3), v.innerHTML = $a12bcf4f10be538e$var$W(0, 3), f.type = 'checkbox', $a12bcf4f10be538e$var$V(l, 'section__toggle-wrapper'), $a12bcf4f10be538e$var$V(f, 'section__toggle'), $a12bcf4f10be538e$var$V(m, 'toggle__icon-on'), $a12bcf4f10be538e$var$V(v, 'toggle__icon-off'), $a12bcf4f10be538e$var$V(_, 'toggle__icon'), $a12bcf4f10be538e$var$V(u, 'toggle__icon-circle'), $a12bcf4f10be538e$var$V(p, 'toggle__label'), $a12bcf4f10be538e$var$E(_, $a12bcf4f10be538e$var$i, 'true'), n ? ($a12bcf4f10be538e$var$V(l, 'toggle-service'), $a12bcf4f10be538e$var$E(f, $a12bcf4f10be538e$var$s, a), r.se[a][t] = f) : r.ae[t] = f, n ? ((e)=>{
        $a12bcf4f10be538e$var$R(f, 'change', ()=>{
            const t = r.se[e], o = r.ae[e];
            c.Z[e] = [];
            for(let o in t){
                const n = t[o];
                n.checked && c.Z[e].push(n.value);
            }
            o.checked = c.Z[e].length > 0;
        });
    })(a) : ((e)=>{
        $a12bcf4f10be538e$var$R(f, $a12bcf4f10be538e$var$d, ()=>{
            const t = r.se[e], o = f.checked;
            c.Z[e] = [];
            for(let n in t)t[n].checked = o, o && c.Z[e].push(n);
        });
    })(t), f.value = t, p.textContent = e.replace(/<.*>.*<\/.*>/gm, ''), $a12bcf4f10be538e$var$H(u, v), $a12bcf4f10be538e$var$H(u, m), $a12bcf4f10be538e$var$H(_, u), c.D) (o.readOnly || o.enabled) && (f.checked = !0);
    else if (n) {
        const e = c.Y[a];
        f.checked = o.readOnly || $a12bcf4f10be538e$var$b(e, t);
    } else $a12bcf4f10be538e$var$b(c.R, t) && (f.checked = !0);
    return o.readOnly && (f.disabled = !0), $a12bcf4f10be538e$var$H(l, f), $a12bcf4f10be538e$var$H(l, _), $a12bcf4f10be538e$var$H(l, p), l;
}
const $a12bcf4f10be538e$var$ve = ()=>{
    const e = $a12bcf4f10be538e$var$k('span');
    return $a12bcf4f10be538e$var$g.ne.Ke || ($a12bcf4f10be538e$var$g.ne.Ke = e), e;
}, $a12bcf4f10be538e$var$ye = (e, t)=>{
    const o = $a12bcf4f10be538e$var$g.o, n = $a12bcf4f10be538e$var$g.ne, { hide: a, showPreferences: s, acceptCategory: u } = e, p = o.u && o.u.consentModal;
    if (!p) return;
    const m = p.acceptAllBtn, b = p.acceptNecessaryBtn, v = p.showPreferencesBtn, y = p.closeIconLabel, h = p.footer, C = p.label, w = p.title, S = (e)=>{
        a(), u(e);
    };
    if (!n.Qe) {
        n.Qe = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), n.he = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), n.We = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), n.Xe = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), n.Ye = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$V(n.Qe, 'cm-wrapper'), $a12bcf4f10be538e$var$V(n.he, 'cm'), $a12bcf4f10be538e$var$I(n.We, 'body'), $a12bcf4f10be538e$var$I(n.Xe, 'texts'), $a12bcf4f10be538e$var$I(n.Ye, 'btns'), $a12bcf4f10be538e$var$E(n.he, 'role', 'dialog'), $a12bcf4f10be538e$var$E(n.he, 'aria-modal', 'true'), $a12bcf4f10be538e$var$E(n.he, $a12bcf4f10be538e$var$i, 'false'), $a12bcf4f10be538e$var$E(n.he, 'aria-describedby', 'cm__desc'), C ? $a12bcf4f10be538e$var$E(n.he, 'aria-label', C) : w && $a12bcf4f10be538e$var$E(n.he, 'aria-labelledby', 'cm__title');
        const e = 'box', t = o.i.guiOptions, a = t && t.consentModal, s = (a && a.layout || e).split(' ')[0] === e;
        w && y && s && (n.Le || (n.Le = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), n.Le.innerHTML = $a12bcf4f10be538e$var$W(), $a12bcf4f10be538e$var$I(n.Le, 'btn'), $a12bcf4f10be538e$var$I(n.Le, 'btn--close'), $a12bcf4f10be538e$var$R(n.Le, $a12bcf4f10be538e$var$d, ()=>{
            S([]);
        }), $a12bcf4f10be538e$var$H(n.We, n.Le)), $a12bcf4f10be538e$var$E(n.Le, 'aria-label', y)), $a12bcf4f10be538e$var$H(n.We, n.Xe), (m || b || v) && $a12bcf4f10be538e$var$H(n.We, n.Ye), n.be = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$E(n.be, 'tabIndex', -1), $a12bcf4f10be538e$var$H(n.he, n.be), $a12bcf4f10be538e$var$H(n.he, n.We), $a12bcf4f10be538e$var$H(n.Qe, n.he);
    }
    w && (n.Ze || (n.Ze = $a12bcf4f10be538e$var$k('h2'), n.Ze.className = n.Ze.id = 'cm__title', $a12bcf4f10be538e$var$H(n.Xe, n.Ze)), n.Ze.innerHTML = w);
    let x = p.description;
    if (x && (o.V && (x = x.replace('{{revisionMessage}}', o.I ? '' : p.revisionMessage || '')), n.et || (n.et = $a12bcf4f10be538e$var$k('p'), n.et.className = n.et.id = 'cm__desc', $a12bcf4f10be538e$var$H(n.Xe, n.et)), n.et.innerHTML = x), m && (n.tt || (n.tt = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$H(n.tt, $a12bcf4f10be538e$var$ve()), $a12bcf4f10be538e$var$I(n.tt, 'btn'), $a12bcf4f10be538e$var$E(n.tt, $a12bcf4f10be538e$var$f, 'all'), $a12bcf4f10be538e$var$R(n.tt, $a12bcf4f10be538e$var$d, ()=>{
        S('all');
    })), n.tt.firstElementChild.innerHTML = m), b && (n.Ie || (n.Ie = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$H(n.Ie, $a12bcf4f10be538e$var$ve()), $a12bcf4f10be538e$var$I(n.Ie, 'btn'), $a12bcf4f10be538e$var$E(n.Ie, $a12bcf4f10be538e$var$f, 'necessary'), $a12bcf4f10be538e$var$R(n.Ie, $a12bcf4f10be538e$var$d, ()=>{
        S([]);
    })), n.Ie.firstElementChild.innerHTML = b), v && (n.ot || (n.ot = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$r), $a12bcf4f10be538e$var$H(n.ot, $a12bcf4f10be538e$var$ve()), $a12bcf4f10be538e$var$I(n.ot, 'btn'), $a12bcf4f10be538e$var$I(n.ot, 'btn--secondary'), $a12bcf4f10be538e$var$E(n.ot, $a12bcf4f10be538e$var$f, 'show'), $a12bcf4f10be538e$var$R(n.ot, 'mouseenter', ()=>{
        o.N || $a12bcf4f10be538e$var$me(e, t);
    }), $a12bcf4f10be538e$var$R(n.ot, $a12bcf4f10be538e$var$d, s)), n.ot.firstElementChild.innerHTML = v), n.nt || (n.nt = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$I(n.nt, $a12bcf4f10be538e$var$l), m && $a12bcf4f10be538e$var$H(n.nt, n.tt), b && $a12bcf4f10be538e$var$H(n.nt, n.Ie), (m || b) && $a12bcf4f10be538e$var$H(n.We, n.nt), $a12bcf4f10be538e$var$H(n.Ye, n.nt)), n.ot && !n.st && (n.st = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), n.Ie && n.tt ? ($a12bcf4f10be538e$var$I(n.st, $a12bcf4f10be538e$var$l), $a12bcf4f10be538e$var$H(n.st, n.ot), $a12bcf4f10be538e$var$H(n.Ye, n.st)) : ($a12bcf4f10be538e$var$H(n.nt, n.ot), $a12bcf4f10be538e$var$I(n.nt, $a12bcf4f10be538e$var$l + '--uneven'))), h) {
        if (!n.ct) {
            let e = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), t = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c);
            n.ct = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), $a12bcf4f10be538e$var$I(e, 'footer'), $a12bcf4f10be538e$var$I(t, 'links'), $a12bcf4f10be538e$var$I(n.ct, 'link-group'), $a12bcf4f10be538e$var$H(t, n.ct), $a12bcf4f10be538e$var$H(e, t), $a12bcf4f10be538e$var$H(n.he, e);
        }
        n.ct.innerHTML = h;
    }
    $a12bcf4f10be538e$var$pe(0), o.T || (o.T = !0, $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.ue, $a12bcf4f10be538e$var$_, n.he), t(e), $a12bcf4f10be538e$var$H(n.Ce, n.Qe), $a12bcf4f10be538e$var$X(n.he), setTimeout(()=>$a12bcf4f10be538e$var$V(n.Qe, 'cc--anim'), 100)), $a12bcf4f10be538e$var$Z(1), $a12bcf4f10be538e$var$J(n.We, e, $a12bcf4f10be538e$var$me, t);
}, $a12bcf4f10be538e$var$he = (e)=>{
    if (!$a12bcf4f10be538e$var$y(e)) return null;
    if (e in $a12bcf4f10be538e$var$g.o._) return e;
    let t = e.slice(0, 2);
    return t in $a12bcf4f10be538e$var$g.o._ ? t : null;
}, $a12bcf4f10be538e$var$Ce = ()=>$a12bcf4f10be538e$var$g.o.l || $a12bcf4f10be538e$var$g.o.i.language.default, $a12bcf4f10be538e$var$we = (e)=>{
    e && ($a12bcf4f10be538e$var$g.o.l = e);
}, $a12bcf4f10be538e$var$Se = async (e)=>{
    const t = $a12bcf4f10be538e$var$g.o;
    let o = $a12bcf4f10be538e$var$he(e) ? e : $a12bcf4f10be538e$var$Ce(), n = t._[o];
    if ($a12bcf4f10be538e$var$y(n) ? n = await (async (e)=>{
        try {
            const t = await fetch(e);
            return await t.json();
        } catch (e) {
            return console.error(e), !1;
        }
    })(n) : $a12bcf4f10be538e$var$C(n) && (n = await n()), !n) throw `Could not load translation for the '${o}' language`;
    return t.u = n, $a12bcf4f10be538e$var$we(o), !0;
}, $a12bcf4f10be538e$var$xe = ()=>{
    let e = $a12bcf4f10be538e$var$g.o.i.language.rtl, t = $a12bcf4f10be538e$var$g.ne.Ce;
    e && t && ($a12bcf4f10be538e$var$v(e) || (e = [
        e
    ]), $a12bcf4f10be538e$var$b(e, $a12bcf4f10be538e$var$g.o.l) ? $a12bcf4f10be538e$var$V(t, 'cc--rtl') : $a12bcf4f10be538e$var$j(t, 'cc--rtl'));
}, $a12bcf4f10be538e$var$Me = ()=>{
    const e = $a12bcf4f10be538e$var$g.ne;
    if (e.Ce) return;
    e.Ce = $a12bcf4f10be538e$var$k($a12bcf4f10be538e$var$c), e.Ce.id = 'cc-main', e.Ce.setAttribute('data-nosnippet', ''), $a12bcf4f10be538e$var$xe();
    let t = $a12bcf4f10be538e$var$g.o.i.root;
    t && $a12bcf4f10be538e$var$y(t) && (t = document.querySelector(t)), (t || e.Ue.body).appendChild(e.Ce);
}, $a12bcf4f10be538e$var$De = (e)=>$a12bcf4f10be538e$var$te(()=>localStorage.removeItem(e)), $a12bcf4f10be538e$var$Te = (e, t)=>{
    if (t instanceof RegExp) return e.filter((e)=>t.test(e));
    {
        const o = $a12bcf4f10be538e$var$m(e, t);
        return o > -1 ? [
            e[o]
        ] : [];
    }
}, $a12bcf4f10be538e$var$ke = (e)=>{
    const { hostname: t, protocol: o } = location, { name: n, path: a, domain: s, sameSite: c, useLocalStorage: r, secure: i } = $a12bcf4f10be538e$var$g.t.cookie, l = e ? (()=>{
        const e = $a12bcf4f10be538e$var$g.o.S, t = e ? new Date - e : 0;
        return 864e5 * $a12bcf4f10be538e$var$B() - t;
    })() : 864e5 * $a12bcf4f10be538e$var$B(), d = new Date;
    d.setTime(d.getTime() + l), $a12bcf4f10be538e$var$g.o.p.expirationTime = d.getTime();
    const f = JSON.stringify($a12bcf4f10be538e$var$g.o.p);
    let _ = n + '=' + encodeURIComponent(f) + (0 !== l ? '; expires=' + d.toUTCString() : '') + '; Path=' + a + '; SameSite=' + c;
    $a12bcf4f10be538e$var$b(t, '.') && (_ += '; Domain=' + s), i && 'https:' === o && (_ += '; Secure'), r ? ((e, t)=>{
        $a12bcf4f10be538e$var$te(()=>localStorage.setItem(e, t));
    })(n, f) : document.cookie = _, $a12bcf4f10be538e$var$g.o.p;
}, $a12bcf4f10be538e$var$Ee = (e, t, o)=>{
    if (0 === e.length) return;
    const n = o || $a12bcf4f10be538e$var$g.t.cookie.domain, a = t || $a12bcf4f10be538e$var$g.t.cookie.path, s = 'www.' === n.slice(0, 4), c = s && n.substring(4), r = (e, t)=>{
        t && '.' !== t.slice(0, 1) && (t = '.' + t), document.cookie = e + '=; path=' + a + (t ? '; domain=' + t : '') + '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };
    for (const t of e)r(t, o), o || r(t, n), s && r(t, c);
}, $a12bcf4f10be538e$var$Ae = (e)=>{
    const t = e || $a12bcf4f10be538e$var$g.t.cookie.name, o = $a12bcf4f10be538e$var$g.t.cookie.useLocalStorage;
    var n;
    return ((e, t)=>{
        let o;
        return o = $a12bcf4f10be538e$var$te(()=>JSON.parse(t ? e : decodeURIComponent(e)), !0) || {}, o;
    })(o ? (n = t, $a12bcf4f10be538e$var$te(()=>localStorage.getItem(n)) || '') : $a12bcf4f10be538e$var$Ne(t, !0), o);
}, $a12bcf4f10be538e$var$Ne = (e, t)=>{
    const o = document.cookie.match('(^|;)\\s*' + e + '\\s*=\\s*([^;]+)');
    return o ? t ? o.pop() : e : '';
}, $a12bcf4f10be538e$var$He = (e)=>{
    const t = document.cookie.split(/;\s*/), o = [];
    for (const n of t){
        let t = n.split('=')[0];
        e ? $a12bcf4f10be538e$var$te(()=>{
            e.test(t) && o.push(t);
        }) : o.push(t);
    }
    return o;
}, $a12bcf4f10be538e$export$f733614a75aede52 = (o, n = [])=>{
    ((e, t)=>{
        const { O: o, R: n, B: a, N: s, Z: c, $: r, X: i } = $a12bcf4f10be538e$var$g.o;
        let l = [];
        if (e) {
            $a12bcf4f10be538e$var$v(e) ? l.push(...e) : $a12bcf4f10be538e$var$y(e) && (l = 'all' === e ? o : [
                e
            ]);
            for (const e of o)c[e] = $a12bcf4f10be538e$var$b(l, e) ? $a12bcf4f10be538e$var$w(i[e]) : [];
        } else l = [
            ...n,
            ...r
        ], s && (l = (()=>{
            const e = $a12bcf4f10be538e$var$g.ne.ae;
            if (!e) return [];
            let t = [];
            for(let o in e)e[o].checked && t.push(o);
            return t;
        })());
        l = l.filter((e)=>!$a12bcf4f10be538e$var$b(o, e) || !$a12bcf4f10be538e$var$b(t, e)), l.push(...a), $a12bcf4f10be538e$var$G(l);
    })(o, n), (()=>{
        const e = $a12bcf4f10be538e$var$g.o, { Z: t, B: o, Y: n, X: a, O: s } = e, c = s;
        e.te = $a12bcf4f10be538e$var$F(n);
        for (const s of c){
            const c = a[s], r = $a12bcf4f10be538e$var$w(c), i = t[s] && t[s].length > 0, l = $a12bcf4f10be538e$var$b(o, s);
            if (0 !== r.length) {
                if (n[s] = [], l) n[s].push(...r);
                else if (i) {
                    const e = t[s];
                    n[s].push(...e);
                } else n[s] = e.Z[s];
                n[s] = $a12bcf4f10be538e$var$S(n[s]);
            }
        }
    })(), (()=>{
        const o = $a12bcf4f10be538e$var$g.o;
        o.L = $a12bcf4f10be538e$var$g.t.mode === $a12bcf4f10be538e$var$t && o.D ? $a12bcf4f10be538e$var$$(o.$, o.R) : $a12bcf4f10be538e$var$$(o.R, o.p.categories);
        let n = o.L.length > 0, a = !1;
        for (const e of o.O)o.ee[e] = $a12bcf4f10be538e$var$$(o.Y[e], o.te[e]), o.ee[e].length > 0 && (a = !0);
        const s = $a12bcf4f10be538e$var$g.ne.ae;
        for(const e in s)s[e].checked = $a12bcf4f10be538e$var$b(o.R, e);
        for (const e of o.O){
            const t = $a12bcf4f10be538e$var$g.ne.se[e], n = o.Y[e];
            for(const e in t)t[e].checked = $a12bcf4f10be538e$var$b(n, e);
        }
        o.C || (o.C = new Date), o.M || (o.M = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e)=>(e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16))), o.p = {
            categories: $a12bcf4f10be538e$var$F(o.R),
            revision: $a12bcf4f10be538e$var$g.t.revision,
            data: o.h,
            consentTimestamp: o.C.toISOString(),
            consentId: o.M,
            services: $a12bcf4f10be538e$var$F(o.Y),
            languageCode: $a12bcf4f10be538e$var$g.o.l
        }, o.S && (o.p.lastConsentTimestamp = o.S.toISOString());
        let c = !1;
        const r = n || a;
        (o.D || r) && (o.D && (o.D = !1, c = !0), o.S = o.S ? new Date : o.C, o.p.lastConsentTimestamp = o.S.toISOString(), $a12bcf4f10be538e$var$ke(), $a12bcf4f10be538e$var$g.t.autoClearCookies && (c || r) && ((e)=>{
            const t = $a12bcf4f10be538e$var$g.o, o = $a12bcf4f10be538e$var$He(), n = ((e)=>{
                const t = $a12bcf4f10be538e$var$g.o;
                return (e ? t.O : t.L).filter((e)=>{
                    const o = t.P[e];
                    return !!o && !o.readOnly && !!o.autoClear;
                });
            })(e);
            for(const e in t.ee)for (const n of t.ee[e]){
                const a = t.X[e][n].cookies;
                if (!$a12bcf4f10be538e$var$b(t.Y[e], n) && a) for (const e of a){
                    const t = $a12bcf4f10be538e$var$Te(o, e.name);
                    $a12bcf4f10be538e$var$Ee(t, e.path, e.domain);
                }
            }
            for (const a of n){
                const n = t.P[a].autoClear, s = n && n.cookies || [], c = $a12bcf4f10be538e$var$b(t.L, a), r = !$a12bcf4f10be538e$var$b(t.R, a), i = c && r;
                if (e ? r : i) {
                    n.reloadPage && i && (t.j = !0);
                    for (const e of s){
                        const t = $a12bcf4f10be538e$var$Te(o, e.name);
                        $a12bcf4f10be538e$var$Ee(t, e.path, e.domain);
                    }
                }
            }
        })(c), $a12bcf4f10be538e$var$oe()), c && ($a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.ie), $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.le), $a12bcf4f10be538e$var$g.t.mode === $a12bcf4f10be538e$var$e) || (r && $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.de), o.j && (o.j = !1, location.reload()));
    })();
}, $a12bcf4f10be538e$export$d57953daf19d40f0 = (e)=>{
    const t = $a12bcf4f10be538e$var$g.o.D ? [] : $a12bcf4f10be538e$var$g.o.R;
    return $a12bcf4f10be538e$var$b(t, e);
}, $a12bcf4f10be538e$export$954bc960519baaed = (e, t)=>{
    const { O: o, X: n } = $a12bcf4f10be538e$var$g.o;
    if (!(e && t && $a12bcf4f10be538e$var$y(t) && $a12bcf4f10be538e$var$b(o, t) && 0 !== $a12bcf4f10be538e$var$w(n[t]).length)) return !1;
    ((e, t)=>{
        const o = $a12bcf4f10be538e$var$g.o, { X: n, Z: a, N: s } = o, c = $a12bcf4f10be538e$var$g.ne.se[t] || {}, r = $a12bcf4f10be538e$var$g.ne.ae[t] || {}, i = $a12bcf4f10be538e$var$w(n[t]);
        if (a[t] = [], $a12bcf4f10be538e$var$y(e)) {
            if ('all' === e) {
                if (a[t].push(...i), s) for(let e in c)c[e].checked = !0, $a12bcf4f10be538e$var$T(c[e]);
            } else if ($a12bcf4f10be538e$var$b(i, e) && a[t].push(e), s) for(let t in c)c[t].checked = e === t, $a12bcf4f10be538e$var$T(c[t]);
        } else if ($a12bcf4f10be538e$var$v(e)) for (let o of i){
            const n = $a12bcf4f10be538e$var$b(e, o);
            n && a[t].push(o), s && (c[o].checked = n, $a12bcf4f10be538e$var$T(c[o]));
        }
        const l = 0 === a[t].length;
        o.R = l ? o.R.filter((e)=>e !== t) : $a12bcf4f10be538e$var$S([
            ...o.R,
            t
        ]), s && (r.checked = !l, $a12bcf4f10be538e$var$T(r));
    })(e, t), $a12bcf4f10be538e$export$f733614a75aede52();
}, $a12bcf4f10be538e$export$c6d040ca60661d88 = (e, t)=>{
    const o = $a12bcf4f10be538e$var$g.o.D ? [] : $a12bcf4f10be538e$var$g.o.Y[t] || [];
    return $a12bcf4f10be538e$var$b(o, e);
}, $a12bcf4f10be538e$export$26b2c20fc8da53a0 = (e)=>'' !== $a12bcf4f10be538e$var$Ne(e, !0), $a12bcf4f10be538e$export$6dde6a4e31d2b3a6 = (e, t, o)=>{
    let n = [];
    const a = (e)=>{
        if ($a12bcf4f10be538e$var$y(e)) {
            let t = $a12bcf4f10be538e$var$Ne(e);
            '' !== t && n.push(t);
        } else n.push(...$a12bcf4f10be538e$var$He(e));
    };
    if ($a12bcf4f10be538e$var$v(e)) for (let t of e)a(t);
    else a(e);
    $a12bcf4f10be538e$var$Ee(n, t, o);
}, $a12bcf4f10be538e$export$57bf213be019eeb0 = (e)=>{
    const { ne: t, o: n } = $a12bcf4f10be538e$var$g;
    if (!n.k) {
        if (!n.T) {
            if (!e) return;
            $a12bcf4f10be538e$var$ye($a12bcf4f10be538e$var$Ge, $a12bcf4f10be538e$var$Me);
        }
        n.k = !0, n.J = $a12bcf4f10be538e$var$x(), n.v && $a12bcf4f10be538e$var$K(!0), $a12bcf4f10be538e$var$z(t.he, 1), $a12bcf4f10be538e$var$V(t.ye, $a12bcf4f10be538e$var$o), $a12bcf4f10be538e$var$E(t.he, $a12bcf4f10be538e$var$i, 'false'), setTimeout(()=>{
            $a12bcf4f10be538e$var$U($a12bcf4f10be538e$var$g.ne.be);
        }, 100), $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.fe, $a12bcf4f10be538e$var$_);
    }
}, $a12bcf4f10be538e$export$fe8985bb6374093c = ()=>{
    const { ne: e, o: t, re: n } = $a12bcf4f10be538e$var$g;
    t.k && (t.k = !1, t.v && $a12bcf4f10be538e$var$K(), $a12bcf4f10be538e$var$U(e.Ke, !0), $a12bcf4f10be538e$var$j(e.ye, $a12bcf4f10be538e$var$o), $a12bcf4f10be538e$var$E(e.he, $a12bcf4f10be538e$var$i, 'true'), $a12bcf4f10be538e$var$U(t.J), t.J = null, $a12bcf4f10be538e$var$ee(n._e, $a12bcf4f10be538e$var$_));
}, $a12bcf4f10be538e$export$535e69674d40eb20 = ()=>{
    const e = $a12bcf4f10be538e$var$g.o;
    e.A || (e.N || $a12bcf4f10be538e$var$me($a12bcf4f10be538e$var$Ge, $a12bcf4f10be538e$var$Me), e.A = !0, e.k ? e.U = $a12bcf4f10be538e$var$x() : e.J = $a12bcf4f10be538e$var$x(), $a12bcf4f10be538e$var$z($a12bcf4f10be538e$var$g.ne.we, 2), $a12bcf4f10be538e$var$V($a12bcf4f10be538e$var$g.ne.ye, $a12bcf4f10be538e$var$n), $a12bcf4f10be538e$var$E($a12bcf4f10be538e$var$g.ne.we, $a12bcf4f10be538e$var$i, 'false'), setTimeout(()=>{
        $a12bcf4f10be538e$var$U($a12bcf4f10be538e$var$g.ne.ve);
    }, 100), $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re.fe, $a12bcf4f10be538e$var$u));
}, $a12bcf4f10be538e$export$5b3a895f6cbac580 = ()=>{
    const e = $a12bcf4f10be538e$var$g.o;
    e.A && (e.A = !1, (()=>{
        const e = $a12bcf4f10be538e$export$3bdcc4c9b3764a39(), t = $a12bcf4f10be538e$var$g.o.P, o = $a12bcf4f10be538e$var$g.ne.ae, n = $a12bcf4f10be538e$var$g.ne.se, a = (e)=>$a12bcf4f10be538e$var$b($a12bcf4f10be538e$var$g.o.$, e);
        for(const s in o){
            const c = !!t[s].readOnly;
            o[s].checked = c || (e ? $a12bcf4f10be538e$export$d57953daf19d40f0(s) : a(s));
            for(const t in n[s])n[s][t].checked = c || (e ? $a12bcf4f10be538e$export$c6d040ca60661d88(t, s) : a(s));
        }
    })(), $a12bcf4f10be538e$var$U($a12bcf4f10be538e$var$g.ne.$e, !0), $a12bcf4f10be538e$var$j($a12bcf4f10be538e$var$g.ne.ye, $a12bcf4f10be538e$var$n), $a12bcf4f10be538e$var$E($a12bcf4f10be538e$var$g.ne.we, $a12bcf4f10be538e$var$i, 'true'), e.k ? ($a12bcf4f10be538e$var$U(e.U), e.U = null) : ($a12bcf4f10be538e$var$U(e.J), e.J = null), $a12bcf4f10be538e$var$ee($a12bcf4f10be538e$var$g.re._e, $a12bcf4f10be538e$var$u));
};
var $a12bcf4f10be538e$var$Ge = {
    show: $a12bcf4f10be538e$export$57bf213be019eeb0,
    hide: $a12bcf4f10be538e$export$fe8985bb6374093c,
    showPreferences: $a12bcf4f10be538e$export$535e69674d40eb20,
    hidePreferences: $a12bcf4f10be538e$export$5b3a895f6cbac580,
    acceptCategory: $a12bcf4f10be538e$export$f733614a75aede52
};
const $a12bcf4f10be538e$export$4b6bf64406ec64af = async (e, t)=>{
    if (!$a12bcf4f10be538e$var$he(e)) return !1;
    const o = $a12bcf4f10be538e$var$g.o;
    return !(e === $a12bcf4f10be538e$var$Ce() && !0 !== t || !await $a12bcf4f10be538e$var$Se(e) || ($a12bcf4f10be538e$var$we(e), o.T && $a12bcf4f10be538e$var$ye($a12bcf4f10be538e$var$Ge, $a12bcf4f10be538e$var$Me), o.N && $a12bcf4f10be538e$var$me($a12bcf4f10be538e$var$Ge, $a12bcf4f10be538e$var$Me), $a12bcf4f10be538e$var$xe(), 0));
}, $a12bcf4f10be538e$export$ae3f5fa351e2f57a = ()=>{
    const { F: e, Y: t } = $a12bcf4f10be538e$var$g.o, { accepted: o, rejected: n } = (()=>{
        const { D: e, R: t, O: o } = $a12bcf4f10be538e$var$g.o;
        return {
            accepted: t,
            rejected: e ? [] : o.filter((e)=>!$a12bcf4f10be538e$var$b(t, e))
        };
    })();
    return $a12bcf4f10be538e$var$F({
        acceptType: e,
        acceptedCategories: o,
        rejectedCategories: n,
        acceptedServices: t,
        rejectedServices: $a12bcf4f10be538e$var$P()
    });
}, $a12bcf4f10be538e$export$2cb99e4be0dc4646 = (e, t)=>{
    let o = document.querySelector('script[src="' + e + '"]');
    return new Promise((n)=>{
        if (o) return n(!0);
        if (o = $a12bcf4f10be538e$var$k('script'), $a12bcf4f10be538e$var$h(t)) for(const e in t)$a12bcf4f10be538e$var$E(o, e, t[e]);
        o.onload = ()=>n(!0), o.onerror = ()=>{
            o.remove(), n(!1);
        }, o.src = e, $a12bcf4f10be538e$var$H(document.head, o);
    });
}, $a12bcf4f10be538e$export$3cbc67a40c3171bd = (e)=>{
    let t, o = e.value, n = e.mode, a = !1;
    const s = $a12bcf4f10be538e$var$g.o;
    if ('update' === n) {
        s.h = t = $a12bcf4f10be538e$export$4be65e66cfa2648a('data');
        const e = typeof t == typeof o;
        if (e && 'object' == typeof t) {
            !t && (t = {});
            for(let e in o)t[e] !== o[e] && (t[e] = o[e], a = !0);
        } else !e && t || t === o || (t = o, a = !0);
    } else t = o, a = !0;
    return a && (s.h = t, s.p.data = t, $a12bcf4f10be538e$var$ke(!0)), a;
}, $a12bcf4f10be538e$export$4be65e66cfa2648a = (e, t)=>{
    const o = $a12bcf4f10be538e$var$Ae(t);
    return e ? o[e] : o;
}, $a12bcf4f10be538e$export$44487a86467333c3 = (e)=>{
    const t = $a12bcf4f10be538e$var$g.t, o = $a12bcf4f10be538e$var$g.o.i;
    return e ? t[e] || o[e] : {
        ...t,
        ...o,
        cookie: {
            ...t.cookie
        }
    };
}, $a12bcf4f10be538e$export$3bdcc4c9b3764a39 = ()=>!$a12bcf4f10be538e$var$g.o.D, $a12bcf4f10be538e$export$889ea624f2cb2c57 = async (e)=>{
    const { o: o, t: n, re: a } = $a12bcf4f10be538e$var$g, c = window;
    if (!c._ccRun) {
        if (c._ccRun = !0, ((e)=>{
            const { ne: o, t: n, o: a } = $a12bcf4f10be538e$var$g, c = n, r = a, { cookie: i } = c, l = $a12bcf4f10be538e$var$g.ce, d = e.cookie, f = e.categories, _ = $a12bcf4f10be538e$var$w(f) || [], u = navigator, p = document;
            o.Ue = p, o.ye = p.documentElement, i.domain = location.hostname, r.i = e, r.P = f, r.O = _, r._ = e.language.translations, r.v = !!e.disablePageInteraction, l.ie = e.onFirstConsent, l.le = e.onConsent, l.de = e.onChange, l._e = e.onModalHide, l.fe = e.onModalShow, l.ue = e.onModalReady;
            const { mode: m, autoShow: v, lazyHtmlGeneration: y, autoClearCookies: C, revision: S, manageScriptTags: x, hideFromBots: M } = e;
            m === $a12bcf4f10be538e$var$t && (c.mode = m), 'boolean' == typeof C && (c.autoClearCookies = C), 'boolean' == typeof x && (c.manageScriptTags = x), 'number' == typeof S && S >= 0 && (c.revision = S, r.V = !0), 'boolean' == typeof v && (c.autoShow = v), 'boolean' == typeof y && (c.lazyHtmlGeneration = y), !1 === M && (c.hideFromBots = !1), !0 === c.hideFromBots && u && (r.G = u.userAgent && /bot|crawl|spider|slurp|teoma/i.test(u.userAgent) || u.webdriver), $a12bcf4f10be538e$var$h(d) && (c.cookie = {
                ...i,
                ...d
            }), c.autoClearCookies, r.V, c.manageScriptTags, ((e)=>{
                const { P: t, X: o, Y: n, Z: a, B: s } = $a12bcf4f10be538e$var$g.o;
                for (let c of e){
                    const e = t[c], r = e.services || {}, i = $a12bcf4f10be538e$var$h(r) && $a12bcf4f10be538e$var$w(r) || [];
                    o[c] = {}, n[c] = [], a[c] = [], e.readOnly && (s.push(c), n[c] = i), $a12bcf4f10be538e$var$g.ne.se[c] = {};
                    for (let e of i){
                        const t = r[e];
                        t.Se = !1, o[c][e] = t;
                    }
                }
            })(_), (()=>{
                if (!$a12bcf4f10be538e$var$g.t.manageScriptTags) return;
                const e = $a12bcf4f10be538e$var$g.o, t = $a12bcf4f10be538e$var$D(document, 'script[' + $a12bcf4f10be538e$var$s + ']');
                for (const o of t){
                    let t = $a12bcf4f10be538e$var$N(o, $a12bcf4f10be538e$var$s), n = o.dataset.service || '', a = !1;
                    if (t && '!' === t.charAt(0) && (t = t.slice(1), a = !0), '!' === n.charAt(0) && (n = n.slice(1), a = !0), $a12bcf4f10be538e$var$b(e.O, t) && (e.oe.push({
                        Me: o,
                        xe: !1,
                        ke: a,
                        De: t,
                        Te: n
                    }), n)) {
                        const o = e.X[t];
                        o[n] || (o[n] = {
                            Se: !1
                        });
                    }
                }
            })(), $a12bcf4f10be538e$var$we((()=>{
                const e = $a12bcf4f10be538e$var$g.o.i.language.autoDetect;
                if (e) {
                    const t = {
                        browser: navigator.language,
                        document: document.documentElement.lang
                    }, o = $a12bcf4f10be538e$var$he(t[e]);
                    if (o) return o;
                }
                return $a12bcf4f10be538e$var$Ce();
            })());
        })(e), o.G) return;
        (()=>{
            const e = $a12bcf4f10be538e$var$g.o, o = $a12bcf4f10be538e$var$g.t, n = $a12bcf4f10be538e$var$Ae(), { categories: a, services: s, consentId: c, consentTimestamp: r, lastConsentTimestamp: i, data: l, revision: d } = n, f = $a12bcf4f10be538e$var$v(a);
            e.p = n, e.M = c;
            const _ = !!c && $a12bcf4f10be538e$var$y(c);
            e.C = r, e.C && (e.C = new Date(r)), e.S = i, e.S && (e.S = new Date(i)), e.h = void 0 !== l ? l : null, e.V && _ && d !== o.revision && (e.I = !1), e.D = !(_ && e.I && e.C && e.S && f), o.cookie.useLocalStorage && !e.D && (e.D = (new Date).getTime() > (n.expirationTime || 0), e.D && $a12bcf4f10be538e$var$De(o.cookie.name)), e.D, (()=>{
                const e = $a12bcf4f10be538e$var$g.o;
                for (const o of e.O){
                    const n = e.P[o];
                    if (n.readOnly || n.enabled) {
                        e.$.push(o);
                        const n = e.X[o] || {};
                        for(let a in n)e.Z[o].push(a), e.i.mode === $a12bcf4f10be538e$var$t && e.Y[o].push(a);
                    }
                }
            })(), e.D ? o.mode === $a12bcf4f10be538e$var$t && (e.R = [
                ...e.$
            ]) : (e.Y = {
                ...e.Y,
                ...s
            }, e.Z = {
                ...e.Y
            }, $a12bcf4f10be538e$var$G([
                ...e.B,
                ...a
            ]));
        })();
        const i = $a12bcf4f10be538e$export$3bdcc4c9b3764a39();
        if (!await $a12bcf4f10be538e$var$Se()) return !1;
        if ($a12bcf4f10be538e$var$J(null, r = $a12bcf4f10be538e$var$Ge, $a12bcf4f10be538e$var$me, $a12bcf4f10be538e$var$Me), $a12bcf4f10be538e$var$g.o.D && $a12bcf4f10be538e$var$ye(r, $a12bcf4f10be538e$var$Me), $a12bcf4f10be538e$var$g.t.lazyHtmlGeneration || $a12bcf4f10be538e$var$me(r, $a12bcf4f10be538e$var$Me), n.autoShow && !i && $a12bcf4f10be538e$export$57bf213be019eeb0(!0), i) return $a12bcf4f10be538e$var$oe(), $a12bcf4f10be538e$var$ee(a.le);
        n.mode === $a12bcf4f10be538e$var$t && $a12bcf4f10be538e$var$oe(o.$);
    }
    var r;
}, $a12bcf4f10be538e$export$aad8462122ac592b = (e)=>{
    const { Ce: t, ye: s } = $a12bcf4f10be538e$var$g.ne, { name: c, path: r, domain: i, useLocalStorage: l } = $a12bcf4f10be538e$var$g.t.cookie;
    e && (l ? $a12bcf4f10be538e$var$De(c) : $a12bcf4f10be538e$export$6dde6a4e31d2b3a6(c, r, i));
    for (const { pe: e, ge: t, me: o } of $a12bcf4f10be538e$var$g.o.m)e.removeEventListener(t, o);
    t && t.remove(), s && s.classList.remove($a12bcf4f10be538e$var$a, $a12bcf4f10be538e$var$n, $a12bcf4f10be538e$var$o);
    const d = new $a12bcf4f10be538e$var$p;
    for(const e in $a12bcf4f10be538e$var$g)$a12bcf4f10be538e$var$g[e] = d[e];
    window._ccRun = !1;
};

});



//# sourceMappingURL=path0.0c59f5a0.js.map
